{
  "g": {
    "shortcutSuffix": " ({shortcut})",
    "user": "User",
    "you": "You",
    "currentUser": "Current user",
    "empty": "Empty",
    "noWorkflowsFound": "No workflows found.",
    "comingSoon": "Coming Soon",
    "download": "Download",
    "downloadImage": "Download image",
    "downloadVideo": "Download video",
    "downloadAudio": "Download audio",
    "editOrMaskImage": "Edit or mask image",
    "editImage": "Edit image",
    "decrement": "Decrement",
    "deleteImage": "Delete image",
    "deleteAudioFile": "Delete audio file",
    "increment": "Increment",
    "removeImage": "Remove image",
    "removeVideo": "Remove video",
    "removeTag": "Remove tag",
    "remove": "Remove",
    "chart": "Chart",
    "chartLowercase": "chart",
    "file": "file",
    "selectedFile": "Selected file",
    "none": "None",
    "markdown": "markdown",
    "content": "content",
    "audioProgress": "Audio progress",
    "viewImageOfTotal": "View image {index} of {total}",
    "viewVideoOfTotal": "View video {index} of {total}",
    "imageLightbox": "Image preview",
    "imagePreview": "Image preview - Use arrow keys to navigate between images",
    "videoPreview": "Video preview - Use arrow keys to navigate between videos",
    "viewGrid": "Grid view",
    "imageGallery": "image gallery",
    "galleryImage": "Gallery image",
    "galleryThumbnail": "Gallery thumbnail",
    "previousImage": "Previous image",
    "nextImage": "Next image",
    "switchToGridView": "Switch to grid view",
    "switchToSingleView": "Switch to single view",
    "errorLoadingImage": "Error loading image",
    "errorLoadingVideo": "Error loading video",
    "failedToDownloadImage": "Failed to download image",
    "failedToDownloadVideo": "Failed to download video",
    "calculatingDimensions": "Calculating dimensions",
    "import": "Import",
    "loadAllFolders": "Load All Folders",
    "logoAlt": "ComfyUI Logo",
    "comfyOrgLogoAlt": "ComfyOrg Logo",
    "comfy": "Comfy",
    "refresh": "Refresh",
    "refreshNode": "Refresh Node",
    "terminal": "Terminal",
    "logs": "Logs",
    "videoFailedToLoad": "Video failed to load",
    "audioFailedToLoad": "Audio failed to load",
    "liveSamplingPreview": "Live sampling preview",
    "extensionName": "Extension Name",
    "reloadToApplyChanges": "Reload to apply changes",
    "insert": "Insert",
    "systemInfo": "System Info",
    "devices": "Devices",
    "about": "About",
    "add": "Add",
    "confirm": "Confirm",
    "confirmed": "Confirmed",
    "reset": "Reset",
    "resetAll": "Reset All",
    "clearFilters": "Clear Filters",
    "resetAllKeybindingsTooltip": "Reset all keybindings to default",
    "resetAllKeybindingsTitle": "Reset all keybindings?",
    "resetAllKeybindingsMessage": "All keybindings will be reset to their default values. This cannot be undone.",
    "allKeybindingsReset": "All keybindings reset to default",
    "removeAllKeybindingsTitle": "Remove all keybindings?",
    "removeAllKeybindingsMessage": "All keybindings for this command will be removed",
    "removeAll": "Remove all",
    "changeKeybinding": "Change keybinding",
    "addNewKeybinding": "Add new keybinding",
    "resetToDefault": "Reset to default",
    "removeKeybinding": "Remove keybinding",
    "nMoreKeybindings": "+ {count} more",
    "customizeFolder": "Customize Folder",
    "icon": "Icon",
    "color": "Color",
    "error": "Error",
    "enter": "Enter",
    "enterSubgraph": "Enter Subgraph",
    "inSubgraph": "in subgraph '{name}'",
    "resizeFromBottomRight": "Resize from bottom-right corner",
    "resizeFromTopRight": "Resize from top-right corner",
    "resizeFromBottomLeft": "Resize from bottom-left corner",
    "resizeFromTopLeft": "Resize from top-left corner",
    "info": "Node Info",
    "bookmark": "Save to Library",
    "moreOptions": "More Options",
    "more": "More",
    "loading": "Loading",
    "loadingPanel": "Loading {panel} panel...",
    "preview": "PREVIEW",
    "addNodeFilterCondition": "Add node filter condition",
    "architecture": "Architecture",
    "author": "Author",
    "usageHint": "Usage hint",
    "triggerPhrase": "Trigger phrase",
    "findIssues": "Find Issues",
    "findOnGithub": "Find on GitHub",
    "getHelpAction": "Get Help",
    "reportIssue": "Send Report",
    "reportIssueTooltip": "Submit the error report to Comfy Org",
    "reportSent": "Report Submitted",
    "copyToClipboard": "Copy to Clipboard",
    "copySystemInfo": "Copy System Info",
    "copyAll": "Copy All",
    "openNewIssue": "Open New Issue",
    "showReport": "Show Report",
    "imageFailedToLoad": "Image failed to load",
    "imageDoesNotExist": "Image does not exist",
    "unknownFile": "Unknown file",
    "reconnecting": "Reconnecting",
    "reconnected": "Reconnected",
    "disconnectedFromBackend": "Disconnected from backend. Check if the server is running.",
    "delete": "Delete",
    "rename": "Rename",
    "save": "Save",
    "saveAnyway": "Save Anyway",
    "saving": "Saving",
    "no": "No",
    "on": "On",
    "off": "Off",
    "cancel": "Cancel",
    "close": "Close",
    "closeDialog": "Close dialog",
    "showLeftPanel": "Show left panel",
    "hideLeftPanel": "Hide left panel",
    "showRightPanel": "Show right panel",
    "hideRightPanel": "Hide right panel",
    "or": "or",
    "defaultBanner": "default banner",
    "enableOrDisablePack": "Enable or disable pack",
    "openManager": "Open Manager",
    "manageExtensions": "Manage extensions",
    "gallery": "Gallery",
    "graphNavigation": "Graph navigation",
    "dropYourFileOr": "Drop your file or",
    "back": "Back",
    "previous": "Previous",
    "next": "Next",
    "submit": "Submit",
    "install": "Install",
    "installing": "Installing",
    "overwrite": "Overwrite",
    "customize": "Customize",
    "experimental": "BETA",
    "deprecated": "DEPR",
    "devOnly": "DEV",
    "loadWorkflow": "Load Workflow",
    "goToNode": "Go to Node",
    "setAsBackground": "Set as Background",
    "customBackground": "Custom Background",
    "settings": "Settings",
    "searchWorkflows": "Search Workflows",
    "scrollLeft": "Scroll Left",
    "scrollRight": "Scroll Right",
    "searchSettings": "Search Settings",
    "searchNodes": "Search Nodes",
    "searchModels": "Search Models",
    "searchKeybindings": "Search Keybindings",
    "searchExtensions": "Search Extensions",
    "search": "Search",
    "searchPlaceholder": "Search {subject}...",
    "downloadWithSize": "Download ({size})",
    "noResultsFound": "No Results Found",
    "noResults": "No Results",
    "searchFailedMessage": "We couldn't find any settings matching your search. Try adjusting your search terms.",
    "noTasksFound": "No Tasks Found",
    "noTasksFoundMessage": "There are no tasks in the queue.",
    "newFolder": "New Folder",
    "enableAll": "Enable All",
    "disableAll": "Disable All",
    "enableSelected": "Enable Selected",
    "disableSelected": "Disable Selected",
    "disableThirdParty": "Disable Third-Party",
    "core": "Core",
    "custom": "Custom",
    "command": "Command",
    "keybinding": "Keybinding",
    "keybindings": "Keybindings",
    "extensions": "Extensions",
    "upload": "Upload",
    "export": "Export",
    "workflow": "Workflow",
    "success": "Success",
    "ok": "OK",
    "feedback": "Feedback",
    "continue": "Continue",
    "control_after_generate": "control after generate",
    "control_before_generate": "control before generate",
    "choose_file_to_upload": "choose file to upload",
    "uploadAlreadyInProgress": "Upload already in progress",
    "uploadTimedOut": "Upload timed out. Please try again.",
    "capture": "capture",
    "nodes": "Nodes",
    "nodesCount": "{count} node | {count} nodes",
    "addNode": "Add a node...",
    "filterBy": "Filter by:",
    "filterByType": "Filter by {type}...",
    "mostRelevant": "Most relevant",
    "favorites": "Favorites",
    "bookmarked": "Bookmarked",
    "essentials": "Essentials",
    "input": "Input",
    "output": "Output",
    "community": "Community",
    "all": "All",
    "versionMismatchWarning": "Version Compatibility Warning",
    "versionMismatchWarningMessage": "{warning}: {detail} Visit https://docs.comfy.org/installation/update_comfyui#common-update-issues for update instructions.",
    "frontendOutdated": "Frontend version {frontendVersion} is outdated. Backend requires {requiredVersion} or higher.",
    "frontendNewer": "Frontend version {frontendVersion} may not be compatible with backend version {backendVersion}.",
    "updateFrontend": "Update Frontend",
    "dismiss": "Dismiss",
    "update": "Update",
    "updated": "Updated",
    "resultsCount": "Found {count} Results",
    "status": "Status",
    "description": "Description",
    "warning": "Warning",
    "name": "Name",
    "category": "Category",
    "categories": "Categories",
    "sort": "Sort",
    "source": "Source",
    "filter": "Filter",
    "apply": "Apply",
    "use": "Use",
    "enabled": "Enabled",
    "installed": "Installed",
    "restart": "Restart",
    "missing": "Missing",
    "inProgress": "In progress",
    "completed": "Completed",
    "completedWithCheckmark": "Completed ✓",
    "downloading": "Downloading",
    "interrupted": "Interrupted",
    "queued": "Queued",
    "running": "Running",
    "failed": "Failed",
    "cancelled": "Cancelled",
    "job": "Job",
    "asset": "{count} asset | {count} assets",
    "untitled": "Untitled",
    "emDash": "—",
    "enabling": "Enabling {id}",
    "disabling": "Disabling {id}",
    "updating": "Updating {id}",
    "migrate": "Migrate",
    "updateAvailable": "Update Available",
    "login": "Login",
    "learnMore": "Learn more",
    "amount": "Amount",
    "unknownError": "Unknown error",
    "title": "Title",
    "edit": "Edit",
    "copy": "Copy",
    "copyJobId": "Copy Job ID",
    "copied": "Copied",
    "relativeTime": {
      "now": "now",
      "yearsAgo": "{count}y ago",
      "monthsAgo": "{count}mo ago",
      "weeksAgo": "{count}w ago",
      "daysAgo": "{count}d ago",
      "hoursAgo": "{count}h ago",
      "minutesAgo": "{count}min ago"
    },
    "jobIdCopied": "Job ID copied to clipboard",
    "failedToCopyJobId": "Failed to copy job ID",
    "imageUrl": "Image URL",
    "clear": "Clear",
    "clearAll": "Clear all",
    "copyURL": "Copy URL",
    "releaseTitle": "{package} {version} Release",
    "itemsSelected": "No items selected | {count} item selected | {count} items selected",
    "multiSelectDropdown": "Multi-select dropdown",
    "singleSelectDropdown": "Single-select dropdown",
    "progressCountOf": "of",
    "modifyKeybinding": "Modify keybinding",
    "setAKeybindingForTheFollowing": "Set a keybinding for the following:",
    "enterYourKeybind": "Enter your keybind",
    "browserReservedKeybinding": "This shortcut is reserved by some browsers and may have unexpected results.",
    "browserReservedKeybindingTooltip": "This shortcut conflicts with browser-reserved shortcuts",
    "keybindingAlreadyExists": "Keybinding already exists on",
    "keybindingPresets": {
      "importPreset": "Import preset",
      "importKeybindingPreset": "Import keybinding preset",
      "exportPreset": "Export preset",
      "saveChanges": "Save Changes",
      "saveAsNewPreset": "Save as new preset",
      "resetToDefault": "Reset to default",
      "deletePreset": "Delete preset",
      "unsavedChangesTo": "Unsaved changes to {name}",
      "unsavedChangesMessage": "You have unsaved changes that will be lost if you switch without saving.",
      "discardAndSwitch": "Discard and Switch",
      "saveAndSwitch": "Save and Switch",
      "deletePresetTitle": "Delete the current preset?",
      "deletePresetWarning": "This preset will be deleted. This cannot be undone.",
      "presetSaved": "Preset \"{name}\" saved",
      "presetDeleted": "Preset \"{name}\" deleted",
      "presetImported": "Keybinding preset imported",
      "invalidPresetFile": "Preset file must be valid JSON exported from ComfyUI",
      "invalidPresetName": "Preset name must not be empty, \"default\", start with a dot, contain path separators, or end with .json",
      "loadPresetFailed": "Failed to load preset \"{name}\"",
      "deletePresetFailed": "Failed to delete preset \"{name}\"",
      "overwritePresetTitle": "Overwrite Preset",
      "overwritePresetMessage": "A preset named \"{name}\" already exists. Overwrite it?",
      "presetNamePrompt": "Enter a name for the preset",
      "default": "Default Preset"
    },
    "commandProhibited": "Command {command} is prohibited. Contact an administrator for more information.",
    "startRecording": "Start Recording",
    "stopRecording": "Stop Recording",
    "micPermissionDenied": "Microphone permission denied",
    "noAudioRecorded": "No audio recorded",
    "nodesRunning": "nodes running",
    "duplicate": "Duplicate",
    "itemsCopiedToClipboard": "Items copied to clipboard",
    "selectItemsToCopy": "Select items to copy",
    "nothingToCopy": "Nothing to copy",
    "selectItemsToDuplicate": "Select items to duplicate",
    "nothingToDuplicate": "Nothing to duplicate",
    "selectItemsToDelete": "Select items to delete",
    "nothingToDelete": "Nothing to delete",
    "batchRename": "Batch rename",
    "enterBaseName": "Enter base name",
    "enterNewName": "Enter new name",
    "enterNewNamePrompt": "Enter new name:",
    "selectItemsToRename": "Select items to rename",
    "nothingToRename": "Nothing to rename",
    "moreWorkflows": "More workflows",
    "seeTutorial": "See a tutorial",
    "nodeRenderError": "Node Render Error",
    "nodeContentError": "Node Content Error",
    "nodeHeaderError": "Node Header Error",
    "nodeSlotsError": "Node Slots Error",
    "nodeWidgetsError": "Node Widgets Error",
    "frameNodes": "Frame Nodes",
    "listening": "Listening...",
    "ready": "Ready",
    "play": "Play",
    "pause": "Pause",
    "playPause": "Play/Pause",
    "playRecording": "Play Recording",
    "playing": "Playing",
    "skipToStart": "Skip to Start",
    "skipToEnd": "Skip to End",
    "stopPlayback": "Stop Playback",
    "playbackSpeed": "Playback Speed",
    "volume": "Volume",
    "halfSpeed": "0.5x",
    "1x": "1x",
    "2x": "2x",
    "beta": "BETA",
    "comfyCloud": "Comfy Cloud",
    "nightly": "NIGHTLY",
    "profile": "Profile",
    "noItems": "No items",
    "preloadError": "A required resource failed to load. Please reload the page.",
    "preloadErrorTitle": "Loading Error",
    "recents": "Recents",
    "partner": "Partner",
    "blueprints": "Blueprints",
    "partnerNodes": "Partner Nodes",
    "collapseAll": "Collapse all",
    "expandAll": "Expand all"
  },
  "manager": {
    "title": "Nodes Manager",
    "nodePackInfo": "Node Pack Info",
    "basicInfo": "Basic Info",
    "actions": "Actions",
    "selected": "Selected",
    "legacyMenuNotAvailable": "Legacy manager menu is not available, defaulting to the new manager menu.",
    "incompatibleVersion": {
      "title": "ComfyUI-Manager upgrade required",
      "message": "Please upgrade ComfyUI-Manager to version 4.2.1 or higher.\n• Desktop: Update the ComfyUI Desktop app\n• Standalone: Run pip install -U comfyui-manager and restart\nLearn more: https://github.com/Comfy-Org/ComfyUI-Manager"
    },
    "legacyManagerUI": "Use Legacy UI",
    "legacyManagerUIDescription": "To use the legacy Manager UI, start ComfyUI with --enable-manager-legacy-ui",
    "legacyManagerSearchTip": "Looking for ComfyUI-Manager? You can enable the legacy manager UI by starting ComfyUI with the --enable-manager-legacy-ui flag.",
    "failed": "Failed",
    "failedToInstall": "Failed to Install",
    "installError": "Install Error",
    "importFailedGenericError": "Package failed to import. Check the console for more details.",
    "noNodesFound": "No nodes found",
    "noNodesFoundDescription": "The pack's nodes either could not be parsed, or the pack is a frontend extension only and doesn't have any nodes.",
    "installationQueue": "Installation Queue",
    "changingVersion": "Changing version from {from} to {to}",
    "dependencies": "Dependencies",
    "inWorkflow": "In Workflow",
    "nav": {
      "allExtensions": "All Extensions",
      "notInstalled": "Not Installed",
      "installedSection": "INSTALLED",
      "allInstalled": "All installed",
      "updatesAvailable": "Updates Available",
      "conflicting": "Conflicting",
      "inWorkflowSection": "IN WORKFLOW",
      "allInWorkflow": "All in: {workflowName}",
      "missingNodes": "Missing Nodes",
      "unresolvedNodes": "Unresolved Nodes"
    },
    "infoPanelEmpty": "Click an item to see the info",
    "applyChanges": "Apply Changes",
    "restartToApplyChanges": "To apply changes, please restart ComfyUI",
    "clickToFinishSetup": "Click",
    "toFinishSetup": "to finish setup",
    "restartingBackend": "Restarting backend to apply changes...",
    "extensionsSuccessfullyInstalled": "Extension(s) successfully installed and are ready to use!",
    "installingDependencies": "Installing dependencies...",
    "loadingVersions": "Loading versions...",
    "selectVersion": "Select Version",
    "downloads": "Downloads",
    "repository": "Repository",
    "uninstall": "Uninstall",
    "uninstalling": "Uninstalling {id}",
    "update": "Update",
    "tryUpdate": "Try Update",
    "tryUpdateTooltip": "Pull latest changes from repository. Nightly versions may have updates that cannot be detected automatically.",
    "uninstallSelected": "Uninstall Selected",
    "updateSelected": "Update Selected",
    "updateAll": "Update All",
    "updatingAllPacks": "Updating all packages",
    "disabledNodesWontUpdate": "Disabled nodes will not be updated",
    "enablePackToChangeVersion": "Enable this pack to change versions",
    "license": "License",
    "nightlyVersion": "Nightly",
    "latestVersion": "Latest",
    "createdBy": "Created By",
    "totalNodes": "Total Nodes",
    "discoverCommunityContent": "Discover community-made Node Packs, Extensions, and more...",
    "errorConnecting": "Error connecting to the Comfy Node Registry.",
    "noResultsFound": "No results found matching your search.",
    "tryDifferentSearch": "Please try a different search query.",
    "emptyState": {
      "allInstalled": {
        "title": "No Extensions Installed",
        "message": "You haven't installed any extensions yet."
      },
      "updateAvailable": {
        "title": "All Up to Date",
        "message": "All your extensions are up to date."
      },
      "conflicting": {
        "title": "No Conflicts Detected",
        "message": "All your extensions are compatible."
      },
      "workflow": {
        "title": "No Extensions in Workflow",
        "message": "This workflow doesn't use any extension nodes."
      },
      "missing": {
        "title": "No Missing Nodes",
        "message": "All required nodes are installed."
      }
    },
    "tryAgainLater": "Please try again later.",
    "gettingInfo": "Getting info...",
    "nodePack": "Node Pack",
    "searchPlaceholder": "Search",
    "version": "Version",
    "lastUpdated": "Last Updated",
    "noDescription": "No description available",
    "installSelected": "Install Selected",
    "installAllMissingNodes": "Install All",
    "unresolvedNodes": {
      "title": "Unresolved Missing Nodes",
      "message": "The following nodes are not installed and could not be found in the registry."
    },
    "allMissingNodesInstalled": "All missing nodes have been successfully installed",
    "packsSelected": "packs selected",
    "mixedSelectionMessage": "Cannot perform bulk action on mixed selection",
    "notAvailable": "Not Available",
    "status": {
      "active": "Active",
      "pending": "Pending",
      "flagged": "Flagged",
      "deleted": "Deleted",
      "banned": "Banned",
      "unknown": "Unknown",
      "conflicting": "Conflicting",
      "importFailed": "Install Error"
    },
    "sort": {
      "downloads": "Most Popular",
      "publisher": "Publisher",
      "created": "Newest",
      "updated": "Updated Recently"
    },
    "filter": {
      "nodePack": "Node Pack",
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "conflicts": {
      "title": "Node Pack Issues Detected!",
      "description": "We've detected conflicts between some of your extensions and the new version of ComfyUI. By updating you risk breaking workflows that rely on those extensions.",
      "info": "If you continue with the update, the conflicting extensions will be disabled automatically. You can review and manage them anytime in the ComfyUI Manager.",
      "extensionAtRisk": "Extension at Risk",
      "conflicts": "Conflicts",
      "importFailedExtensions": "Import Failed Extensions",
      "conflictInfoTitle": "Why is this happening?",
      "installAnyway": "Install Anyway",
      "enableAnyway": "Enable Anyway",
      "understood": "Understood",
      "warningBanner": {
        "title": "Some extensions are disabled due to incompatibility with your current setup",
        "message": "These extensions require versions of system packages  that differ from your current setup. Installing them may override core dependencies and affect other extensions or workflows.",
        "button": "Learn More..."
      },
      "conflictMessages": {
        "comfyui_version": "ComfyUI version mismatch (current: {current}, required: {required})",
        "frontend_version": "Frontend version mismatch (current: {current}, required: {required})",
        "os": "Operating system not supported (current: {current}, required: {required})",
        "accelerator": "GPU/Accelerator not supported (available: {current}, required: {required})",
        "generic": "Compatibility issue (current: {current}, required: {required})",
        "banned": "This package is banned for security reasons",
        "pending": "Security verification pending - compatibility cannot be verified",
        "import_failed": "Import Failed"
      },
      "warningTooltip": "This package may have compatibility issues with your current environment"
    },
    "packInstall": {
      "nodeIdRequired": "Node ID is required for installation"
    }
  },
  "importFailed": {
    "title": "Import Failed",
    "copyError": "Copy Error"
  },
  "issueReport": {
    "helpFix": "Help Fix This"
  },
  "color": {
    "noColor": "No Color",
    "default": "Default",
    "blue": "Blue",
    "green": "Green",
    "red": "Red",
    "pink": "Pink",
    "yellow": "Yellow",
    "brown": "Brown",
    "pale_blue": "Pale Blue",
    "cyan": "Cyan",
    "purple": "Purple",
    "black": "Black",
    "custom": "Custom",
    "hex": "Hex",
    "rgba": "RGBA",
    "saturationBrightness": "Color saturation and brightness",
    "hue": "Hue",
    "alpha": "Alpha"
  },
  "contextMenu": {
    "Inputs": "Inputs",
    "Outputs": "Outputs",
    "Properties": "Properties",
    "Properties Panel": "Properties Panel",
    "Title": "Title",
    "Mode": "Mode",
    "Resize": "Resize",
    "Collapse": "Collapse",
    "Expand": "Expand",
    "Pin": "Pin",
    "Unpin": "Unpin",
    "Clone": "Clone",
    "Remove": "Remove",
    "Colors": "Colors",
    "Shapes": "Shapes",
    "Bypass": "Bypass",
    "Copy (Clipspace)": "Copy (Clipspace)",
    "Add Node": "Add Node",
    "Add Group": "Add Group",
    "Convert to Group Node": "Convert to Group Node",
    "Manage Group Nodes": "Manage Group Nodes",
    "Add Group For Selected Nodes": "Add Group For Selected Nodes",
    "Save Selected as Template": "Save Selected as Template",
    "Node Templates": "Node Templates",
    "Manage": "Manage",
    "Search": "Search",
    "Open in Mask Editor": "Open in Mask Editor",
    "Open Image": "Open Image",
    "Copy Image": "Copy Image",
    "Paste Image": "Paste Image",
    "Save Image": "Save Image",
    "Rename": "Rename",
    "RenameWidget": "Rename Widget",
    "FavoriteWidget": "Favorite Widget",
    "UnfavoriteWidget": "Unfavorite Widget",
    "Copy": "Copy",
    "Duplicate": "Duplicate",
    "Paste": "Paste",
    "Node Info": "Node Info",
    "Adjust Size": "Adjust Size",
    "Minimize Node": "Minimize Node",
    "Expand Node": "Expand Node",
    "Shape": "Shape",
    "Color": "Color",
    "Add Subgraph to Library": "Add Subgraph to Library",
    "Unpack Subgraph": "Unpack Subgraph",
    "Edit Subgraph Widgets": "Edit Subgraph Widgets",
    "Convert to Subgraph": "Convert to Subgraph",
    "Align Selected To": "Align Selected To",
    "Distribute Nodes": "Distribute Nodes",
    "Remove Bypass": "Remove Bypass",
    "Run Branch": "Run Branch",
    "Delete": "Delete",
    "Top": "Top",
    "Bottom": "Bottom",
    "Left": "Left",
    "Right": "Right",
    "Horizontal": "Horizontal",
    "Vertical": "Vertical",
    "new": "new",
    "deprecated": "deprecated",
    "Extensions": "Extensions"
  },
  "icon": {
    "bookmark": "Bookmark",
    "folder": "Folder",
    "star": "Star",
    "heart": "Heart",
    "file": "File",
    "inbox": "Inbox",
    "box": "Box",
    "briefcase": "Briefcase",
    "exclamation-triangle": "Warning"
  },
  "welcome": {
    "title": "Welcome to ComfyUI",
    "getStarted": "Get Started"
  },
  "userSelect": {
    "newUser": "New user",
    "enterUsername": "Enter a username",
    "existingUser": "Existing user",
    "selectUser": "Select a user",
    "next": "Next"
  },
  "notSupported": {
    "title": "Your device is not supported",
    "message": "Only following devices are supported:",
    "illustrationAlt": "Sad girl illustration",
    "learnMore": "Learn More",
    "reportIssue": "Report Issue",
    "supportedDevices": {
      "macos": "MacOS (M1 or later)",
      "windows": "Windows (Nvidia GPU with CUDA support)"
    },
    "continue": "Continue",
    "continueTooltip": "I am sure my device is supported"
  },
  "downloadGit": {
    "title": "Download git",
    "message": "Unable to locate git.  A working copy of git is required for normal operation.",
    "instructions": "Please download and install the latest version for your operating system.  The Download git button below opens the git-scm.com downloads page.",
    "warning": "If you are sure you do not need git installed, or there has been a mistake, you may click Skip to byapss this check.  Attempting to run ComfyUI without a working copy of git is not currently supported.",
    "gitWebsite": "Download git",
    "skip": "Skip"
  },
  "install": {
    "installLocation": "Install Location",
    "migration": "Migration",
    "desktopSettings": "Desktop Settings",
    "chooseInstallationLocation": "Choose Installation Location",
    "gpuPicker": {
      "title": "Choose your hardware setup",
      "recommended": "RECOMMENDED",
      "nvidiaSubtitle": "NVIDIA CUDA",
      "amdSubtitle": "AMD ROCm™",
      "cpuSubtitle": "CPU Mode",
      "manualSubtitle": "Manual Setup",
      "appleMetalDescription": "Leverages your Mac's GPU for faster speed and a better overall experience",
      "nvidiaDescription": "Use your NVIDIA GPU with CUDA acceleration for the best performance.",
      "amdDescription": "Use your AMD GPU with ROCm™ acceleration for the best performance.",
      "cpuDescription": "Use CPU mode for compatibility when GPU acceleration is not available",
      "manualDescription": "Configure ComfyUI manually for advanced setups or unsupported hardware"
    },
    "locationPicker": {
      "title": "Choose where to install ComfyUI",
      "subtitle": "Pick a folder for ComfyUI's files. We'll also set up Python there automatically.",
      "pathPlaceholder": "/Users/username/Documents/ComfyUI",
      "migrationPathPlaceholder": "Select existing ComfyUI installation (optional)",
      "migrateFromExisting": "Migrate from existing installation",
      "migrateDescription": "Copy or link your existing models, custom nodes, and configurations from a previous ComfyUI installation.",
      "chooseDownloadServers": "Choose download servers manually",
      "downloadServersDescription": "Select specific mirror servers for downloading Python, PyPI packages, and PyTorch based on your location."
    },
    "systemLocations": "System Locations",
    "failedToSelectDirectory": "Failed to select directory",
    "pathValidationFailed": "Failed to validate path",
    "pathExists": "Directory already exists - please ensure you have backed up all data",
    "cannotWrite": "Unable to write to the selected path",
    "insufficientFreeSpace": "Insufficient space - minimum free space",
    "isOneDrive": "OneDrive is not supported. Please install ComfyUI in another location.",
    "insideAppInstallDir": "This folder is inside the ComfyUI Desktop application bundle and will be deleted during updates. Choose a directory outside the install folder, such as Documents/ComfyUI.",
    "insideUpdaterCache": "This folder is inside the ComfyUI updater cache, which is cleared on every update. Select a different location for your data.",
    "nonDefaultDrive": "Please install ComfyUI on your system drive (eg. C:\\). Drives with different file systems may cause unpredicable issues. Models and other files can be stored on other drives after installation.",
    "parentMissing": "Path does not exist - create the containing directory first",
    "unhandledError": "Unknown error",
    "installLocationDescription": "Select the directory for ComfyUI's user data. A python environment will be installed to the selected location.",
    "installLocationTooltip": "ComfyUI's user data directory. Stores:\n- Python Environment\n- Models\n- Custom nodes\n",
    "appDataLocationTooltip": "ComfyUI's app data directory. Stores:\n- Logs\n- Server configs",
    "appPathLocationTooltip": "ComfyUI's app asset directory. Stores the ComfyUI code and assets",
    "migrateFromExistingInstallation": "Migrate from Existing Installation",
    "migrationSourcePathDescription": "If you have an existing ComfyUI installation, we can copy/link your existing user files and models to the new installation. Your existing ComfyUI installation will not be affected.",
    "selectItemsToMigrate": "Select Items to Migrate",
    "migrationOptional": "Migration is optional. If you don't have an existing installation, you can skip this step.",
    "desktopAppSettings": "Desktop App Settings",
    "desktopAppSettingsDescription": "Configure how ComfyUI behaves on your desktop. You can change these settings later.",
    "gpu": "GPU",
    "gpuSelection": {
      "selectGpu": "Select GPU",
      "selectGpuDescription": "Select the type of GPU you have",
      "cpuMode": "CPU Mode",
      "cpuModeDescription": "CPU mode is intended for developers and rare edge cases only.",
      "cpuModeDescription2": "If you are not absolutely certain you need this, please ignore this box and select your GPU above.",
      "enableCpuMode": "Enable CPU Mode",
      "nvidiaDescription": "NVIDIA devices are directly supported using pytorch CUDA builds.",
      "mpsDescription": "Apple Metal Performance Shaders are supported using pytorch nightly.",
      "customSkipsPython": "This option skips the normal python setup.",
      "customComfyNeedsPython": "ComfyUI will not work until python is setup",
      "customManualVenv": "Manually configure python venv",
      "customInstallRequirements": "Install all requirements and dependencies (e.g. custom torch)",
      "customMayNotWork": "This is entirely unsupported, and may simply not work"
    },
    "manualConfiguration": {
      "title": "Manual Configuration",
      "requirements": "Requirements",
      "createVenv": "You will need to create a virtual environment in the following directory",
      "virtualEnvironmentPath": "Virtual environment path",
      "restartWhenFinished": "When you have finished configuring the virtual environment, please restart ComfyUI."
    },
    "settings": {
      "autoUpdate": "Automatic Updates",
      "allowMetrics": "Usage Metrics",
      "errorUpdatingConsent": "Error Updating Consent",
      "errorUpdatingConsentDetail": "Failed to update metrics consent settings",
      "autoUpdateDescription": "Automatically download updates when they become available. You will be notified before updates are installed.",
      "allowMetricsDescription": "Help improve ComfyUI by sending anonymous usage metrics. No personal information or workflow content will be collected.",
      "learnMoreAboutData": "Learn more about data collection",
      "dataCollectionDialog": {
        "title": "About Data Collection",
        "whatWeCollect": "What we collect:",
        "whatWeDoNotCollect": "What we don't collect:",
        "collect": {
          "errorReports": "Error message and stack trace",
          "systemInfo": "Hardware, OS type, and app version",
          "userJourneyEvents": "User journey events"
        },
        "doNotCollect": {
          "personalInformation": "Personal information",
          "fileSystemInformation": "File system information",
          "workflowContents": "Workflow contents",
          "customNodeConfigurations": "Custom node configurations"
        },
        "viewFullPolicy": "View full policy"
      },
      "pythonMirrorPlaceholder": "Enter Python mirror URL",
      "pypiMirrorPlaceholder": "Enter PyPI mirror URL",
      "checkingMirrors": "Checking network access to python mirrors...",
      "mirrorsReachable": "Network access to python mirrors is good",
      "mirrorsUnreachable": "Network access to some python mirrors is bad",
      "mirrorSettings": "Mirror Settings"
    },
    "customNodes": "Custom Nodes",
    "customNodesDescription": "Reinstall custom nodes from existing ComfyUI installations.",
    "helpImprove": "Please help improve ComfyUI",
    "moreInfo": "For more info, please read our",
    "privacyPolicy": "privacy policy",
    "metricsEnabled": "Metrics Enabled",
    "metricsDisabled": "Metrics Disabled",
    "updateConsent": "You previously opted in to reporting crashes. We are now tracking event-based metrics to help identify bugs and improve the app. No personal identifiable information is collected."
  },
  "desktopStart": {
    "initialising": "Initialising..."
  },
  "serverStart": {
    "title": "Starting ComfyUI",
    "troubleshoot": "Troubleshoot",
    "reportIssue": "Report Issue",
    "openLogs": "Open Logs",
    "showTerminal": "Show Terminal",
    "copySelectionTooltip": "Copy selection",
    "copyAllTooltip": "Copy all",
    "errorMessage": "Unable to start ComfyUI Desktop",
    "installation": {
      "title": "Installing ComfyUI"
    },
    "process": {
      "initial-state": "Loading...",
      "python-setup": "Setting up Python Environment...",
      "starting-server": "Starting ComfyUI server...",
      "ready": "Loading Human Interface",
      "error": "Unable to start ComfyUI Desktop"
    }
  },
  "serverConfig": {
    "modifiedConfigs": "You have modified the following server configurations. Restart to apply changes.",
    "revertChanges": "Revert Changes",
    "restart": "Restart",
    "restartRequiredToastSummary": "Restart required",
    "restartRequiredToastDetail": "Restart the app to apply server configuration changes."
  },
  "shape": {
    "default": "Default",
    "round": "Round",
    "CARD": "Card",
    "circle": "Circle",
    "arrow": "Arrow",
    "box": "Box"
  },
  "sideToolbar": {
    "sidebar": "Sidebar",
    "themeToggle": "Toggle Theme",
    "helpCenter": "Help Center",
    "logout": "Logout",
    "queue": "Queue",
    "nodeLibrary": "Node Library",
    "nodes": "Nodes",
    "workflows": "Workflows",
    "templates": "Templates",
    "assets": "Assets",
    "mediaAssets": {
      "title": "Media Assets",
      "sortNewestFirst": "Newest first",
      "sortOldestFirst": "Oldest first",
      "sortLongestFirst": "Generation time (longest first)",
      "sortFastestFirst": "Generation time (fastest first)",
      "filterImage": "Image",
      "filterVideo": "Video",
      "filterAudio": "Audio",
      "filter3D": "3D",
      "filterText": "Text",
      "viewSettings": "View settings"
    },
    "backToAssets": "Back to all assets",
    "folderView": {
      "errorSummary": "Failed to load outputs",
      "errorDetail": "Could not retrieve outputs for this job. Please try again."
    },
    "searchAssets": "Search Assets",
    "labels": {
      "queue": "Queue",
      "nodes": "Nodes",
      "models": "Models",
      "assets": "Assets",
      "workflows": "Workflows",
      "templates": "Templates",
      "console": "Console",
      "menu": "Menu",
      "imported": "Imported",
      "generated": "Generated"
    },
    "noFilesFound": "No files found",
    "noImportedFiles": "No imported files found",
    "noGeneratedFiles": "No generated files found",
    "generatedAssetsHeader": "Generated assets",
    "importedAssetsHeader": "Imported assets",
    "activeJobStatus": "Active job: {status}",
    "noFilesFoundMessage": "Upload files or generate content to see them here",
    "browseTemplates": "Browse example templates",
    "openWorkflow": "Open workflow in local file system",
    "newBlankWorkflow": "Create a new blank workflow",
    "nodeLibraryTab": {
      "essentials": "Essentials",
      "allNodes": "All",
      "blueprints": "Blueprints",
      "custom": "Custom",
      "filter": "Filter",
      "filterOptions": {
        "blueprints": "Blueprints",
        "partnerNodes": "Partner Nodes",
        "comfyNodes": "Comfy Nodes",
        "extensions": "Extensions"
      },
      "groupBy": "Group By",
      "sortMode": "Sort Mode",
      "resetView": "Reset View to Default",
      "groupStrategies": {
        "category": "Category",
        "categoryDesc": "Group by node category",
        "module": "Module",
        "moduleDesc": "Group by module source",
        "source": "Source",
        "sourceDesc": "Group by source type (Core, Custom, API)"
      },
      "sortBy": {
        "original": "Categorized",
        "originalDesc": "Keep original order",
        "alphabetical": "A-Z",
        "alphabeticalDesc": "Sort alphabetically within groups"
      },
      "sections": {
        "favorites": "Bookmarks",
        "favoriteNode": "Bookmark Node",
        "unfavoriteNode": "Unbookmark Node",
        "bookmarked": "Bookmarked",
        "subgraphBlueprints": "Subgraph Blueprints",
        "myBlueprints": "My Blueprints",
        "comfyBlueprints": "Comfy Blueprints",
        "partnerNodes": "Partner Nodes",
        "comfyNodes": "Comfy Nodes",
        "extensions": "Extensions"
      },
      "noBookmarkedNodes": "No bookmarks yet"
    },
    "modelLibrary": "Model Library",
    "downloads": "Downloads",
    "queueProgressOverlay": {
      "title": "Queue Progress",
      "total": "Total: {percent}",
      "colonPercent": ": {percent}",
      "inlineTotalLabel": "Total",
      "currentNode": "Current node:",
      "viewAllJobs": "View all jobs",
      "viewList": "List view",
      "viewGrid": "Grid view",
      "running": "running",
      "preview": "Preview",
      "interruptAll": "Interrupt all running jobs",
      "moreOptions": "More options",
      "showAssets": "Show assets",
      "showAssetsPanel": "Show assets panel",
      "queuedSuffix": "queued",
      "clearQueued": "Clear queued",
      "clearHistory": "Clear job history",
      "dockedJobHistory": "Docked Job History",
      "showRunProgressBar": "Show run progress bar",
      "clearHistoryMenuAssetsNote": "Media assets won't be deleted.",
      "filterJobs": "Filter jobs",
      "filterBy": "Filter by",
      "filterAllWorkflows": "All workflows",
      "filterCurrentWorkflow": "Current workflow",
      "searchJobs": "Search...",
      "sortJobs": "Sort jobs",
      "sortBy": "Sort by",
      "activeJobs": "{count} active job | {count} active jobs",
      "activeJobsShort": "{count} active | {count} active",
      "activeJobsSuffix": "active jobs",
      "runningJobsLabel": "{count} running",
      "queuedJobsLabel": "{count} queued",
      "runningQueuedSummary": "{running}, {queued}",
      "jobQueue": "Job Queue",
      "expandCollapsedQueue": "Expand job queue",
      "viewJobHistory": "View active jobs (right-click to clear queue)",
      "noActiveJobs": "No active jobs",
      "stubClipTextEncode": "CLIP Text Encode:",
      "jobCompleted": "Job completed",
      "jobFailed": "Job failed",
      "jobsCompleted": "{count} job completed | {count} jobs completed",
      "jobsFailed": "{count} job failed | {count} jobs failed",
      "jobsAddedToQueue": "{count} job added to queue | {count} jobs added to queue",
      "cancelJobTooltip": "Cancel job",
      "clearQueueTooltip": "Clear queue",
      "clearAllJobsTooltip": "Cancel all running jobs",
      "clearHistoryDialogTitle": "Clear your job queue history?",
      "clearHistoryDialogDescription": "All the finished or failed jobs below will be removed from this Job queue panel.",
      "clearHistoryDialogAssetsNote": "Assets generated by these jobs won’t be deleted and can always be viewed from the assets panel."
    },
    "workflowTab": {
      "confirmDeleteTitle": "Delete workflow?",
      "confirmDelete": "Are you sure you want to delete this workflow?",
      "deleted": "Workflow deleted",
      "deleteFailedTitle": "Delete failed",
      "deleteFailed": "Attempt to delete the workflow failed.",
      "dirtyCloseTitle": "Save Changes?",
      "dirtyClose": "The files below have been changed.  Would you like to save them before closing?",
      "dirtyCloseHint": "Hold Shift to close without prompt",
      "dirtyCloseAnyway": "Close anyway",
      "confirmOverwriteTitle": "Overwrite existing file?",
      "confirmOverwrite": "The file below already exists. Would you like to overwrite it?",
      "workflowTreeType": {
        "browse": "Browse",
        "bookmarks": "Bookmarks",
        "open": "Open"
      }
    }
  },
  "helpCenter": {
    "feedback": "Give Feedback",
    "docs": "Docs",
    "github": "Github",
    "help": "Help & Support",
    "managerExtension": "Manager Extension",
    "more": "More...",
    "whatsNew": "What's New?",
    "clickToLearnMore": "Click to learn more →",
    "loadingReleases": "Loading releases...",
    "recentReleases": "Recent releases",
    "noRecentReleases": "No recent releases",
    "updateAvailable": "Update",
    "desktopUserGuide": "Desktop User Guide",
    "openDevTools": "Open Dev Tools",
    "reinstall": "Re-Install",
    "updateComfyUI": "Update ComfyUI",
    "updateComfyUIStarted": "Update Started",
    "updateComfyUIStartedDetail": "ComfyUI update has been queued. Please wait...",
    "updateComfyUISuccess": "Update Complete",
    "updateComfyUISuccessDetail": "ComfyUI has been updated. Rebooting...",
    "updateComfyUIFailed": "Failed to update ComfyUI. Please try again."
  },
  "releaseToast": {
    "newVersionAvailable": "New update is out!",
    "whatsNew": "See what's new",
    "skip": "Skip",
    "update": "Update",
    "description": "Check out the latest improvements and features in this update."
  },
  "menu": {
    "hideMenu": "Hide Menu",
    "showMenu": "Show Menu",
    "batchCount": "Batch Count",
    "batchCountTooltip": "The number of times the workflow generation should be queued",
    "autoQueue": "Auto Queue",
    "disabled": "Disabled",
    "disabledTooltip": "The workflow will not be automatically queued",
    "instant": "Instant",
    "instantTooltip": "The workflow will be queued instantly after a generation finishes",
    "onChange": "On Change",
    "onChangeTooltip": "The workflow will be queued once a change is made",
    "runWorkflow": "Run workflow (Shift to queue at front)",
    "runWorkflowFront": "Run workflow (Queue at front)",
    "runWorkflowDisabled": "Workflow contains unsupported nodes (highlighted red). Remove these to run the workflow.",
    "run": "Run",
    "stopRunInstant": "Stop Run (Instant)",
    "stopRunInstantTooltip": "Stop running",
    "execute": "Execute",
    "interrupt": "Cancel current run",
    "refresh": "Refresh node definitions",
    "clipspace": "Open Clipspace",
    "resetView": "Reset canvas view",
    "clear": "Clear workflow",
    "toggleBottomPanel": "Toggle Bottom Panel",
    "theme": "Theme",
    "dark": "Dark",
    "light": "Light",
    "manageExtensions": "Extensions",
    "customNodesManager": "Custom Nodes Manager",
    "settings": "Settings",
    "help": "Help",
    "queue": "Queue Panel",
    "fullscreen": "Fullscreen"
  },
  "tabMenu": {
    "duplicateTab": "Duplicate Tab",
    "closeTab": "Close Tab",
    "closeTabsToLeft": "Close Tabs to Left",
    "closeTabsToRight": "Close Tabs to Right",
    "closeOtherTabs": "Close Other Tabs",
    "addToBookmarks": "Add to Bookmarks",
    "removeFromBookmarks": "Remove from Bookmarks"
  },
  "templateWorkflows": {
    "title": "Get Started with a Template",
    "loadingMore": "Loading more templates...",
    "searchPlaceholder": "Search templates...",
    "category": {
      "ComfyUI Examples": "ComfyUI Examples",
      "Custom Nodes": "Custom Nodes",
      "Basics": "Basics",
      "GettingStarted": "Getting Started",
      "Flux": "Flux",
      "ControlNet": "ControlNet",
      "Upscaling": "Upscaling",
      "Video": "Video",
      "Image": "Image",
      "Area Composition": "Area Composition",
      "3D": "3D",
      "Audio": "Audio",
      "LLMs": "LLMs",
      "Image API": "Image API",
      "Video API": "Video API",
      "LLM API": "LLM API",
      "All": "All Templates",
      "Extensions": "Extensions",
      "Partner Nodes": "Partner Nodes",
      "Generation Type": "Generation Type"
    },
    "categories": "Categories",
    "resetFilters": "Clear Filters",
    "sorting": "Sort by",
    "activeFilters": "Filters:",
    "loading": "Loading templates...",
    "noResults": "No templates found",
    "noResultsHint": "Try adjusting your search or filters",
    "allTemplates": "All Templates",
    "modelFilter": "Model Filter",
    "useCaseFilter": "Tasks",
    "licenseFilter": "License",
    "modelsSelected": "{count} Models",
    "useCasesSelected": "{count} Use Cases",
    "runsOnSelected": "{count} Runs On",
    "runsOnFilter": "Runs on",
    "resultsCount": "Showing {count} of {total} templates",
    "sort": {
      "recommended": "Recommended",
      "popular": "Popular",
      "alphabetical": "A → Z",
      "newest": "Newest",
      "searchPlaceholder": "Search...",
      "vramLowToHigh": "VRAM Usage (Low to High)",
      "modelSizeLowToHigh": "Model Size (Low to High)",
      "default": "Default"
    },
    "error": {
      "templateNotFound": "Template \"{templateName}\" not found"
    }
  },
  "templateWidgets": {
    "sort": {
      "searchPlaceholder": "Search..."
    }
  },
  "templates": {
    "logoProviderSeparator": " & "
  },
  "graphCanvasMenu": {
    "canvasMode": "Canvas Mode",
    "canvasToolbar": "Canvas Toolbar",
    "zoomIn": "Zoom In",
    "zoomOut": "Zoom Out",
    "resetView": "Reset View",
    "fitView": "Fit View",
    "selectMode": "Select Mode",
    "panMode": "Pan Mode",
    "toggleMinimap": "Toggle Minimap",
    "select": "Select",
    "hand": "Hand",
    "zoomOptions": "Zoom Options",
    "focusMode": "Focus Mode",
    "hideLinks": "Hide Links",
    "showLinks": "Show Links",
    "toggleLinkVisibility": "Toggle Link Visibility"
  },
  "zoomControls": {
    "label": "Zoom Controls",
    "zoomToFit": "Zoom To Fit",
    "showMinimap": "Show Minimap",
    "hideMinimap": "Hide Minimap"
  },
  "groupNode": {
    "create": "Create group node",
    "enterName": "Enter name"
  },
  "nodeTemplates": {
    "saveAsTemplate": "Save as template",
    "enterName": "Enter name"
  },
  "logsTerminal": {
    "loadError": "Unable to load logs, please ensure you have updated your ComfyUI backend.",
    "resyncError": "Unable to resync logs after the backend reconnected. Reopen the console to retry."
  },
  "workflowService": {
    "exportWorkflow": "Export Workflow",
    "enterFilename": "Enter the filename",
    "enterFilenamePrompt": "Enter the filename:",
    "saveWorkflow": "Save workflow",
    "savedAsApp": "Converted to app workflow",
    "savedAsWorkflow": "Converted to node graph only workflow"
  },
  "subgraphStore": {
    "confirmDeleteTitle": "Delete blueprint?",
    "confirmDelete": "This action will permanently remove the blueprint from your library",
    "saveBlueprint": "Save Subgraph to Library",
    "overwriteBlueprintTitle": "Overwrite existing blueprint?",
    "overwriteBlueprint": "Saving will overwrite the current blueprint with your changes",
    "blueprintName": "Subgraph name",
    "blueprintNamePrompt": "Subgraph name:",
    "promoteOutsideSubgraph": "Can't promote widget when not in subgraph",
    "publish": "Publish Subgraph",
    "publishSuccess": "Saved to Nodes Library",
    "publishSuccessMessage": "You can find your subgraph blueprint in the nodes library under \"Subgraph Blueprints\"",
    "loadFailure": "Failed to load subgraph blueprints",
    "shown": "Shown on node",
    "showAll": "Show all",
    "hidden": "Hidden / nested parameters",
    "hideAll": "Hide all",
    "showRecommended": "Show recommended widgets",
    "cannotDeleteGlobal": "Cannot delete installed blueprints",
    "enterDescription": "Enter a description",
    "searchAliases": "Search Aliases",
    "enterSearchAliases": "Enter search aliases (comma separated)",
    "disconnected": "Disconnected",
    "linked": "(Linked)",
    "promoteWidget": "Promote Widget: {name}",
    "unpromoteWidget": "Un-Promote Widget: {name}"
  },
  "electronFileDownload": {
    "inProgress": "In Progress",
    "pause": "Pause Download",
    "paused": "Paused",
    "resume": "Resume Download",
    "cancel": "Cancel Download",
    "cancelled": "Cancelled"
  },
  "maskEditor": {
    "title": "Mask Editor",
    "openMaskEditor": "Open in Mask Editor",
    "invert": "Invert",
    "clear": "Clear",
    "undo": "Undo",
    "redo": "Redo",
    "rotateLeft": "Rotate Left",
    "rotateRight": "Rotate Right",
    "mirrorHorizontal": "Mirror Horizontal",
    "mirrorVertical": "Mirror Vertical",
    "clickToResetZoom": "Click to reset zoom",
    "brushSettings": "Brush Settings",
    "brushShape": "Brush Shape",
    "colorSelector": "Color Selector",
    "thickness": "Thickness",
    "opacity": "Opacity",
    "hardness": "Hardness",
    "stepSize": "Step Size",
    "smoothingPrecision": "Smoothing Precision",
    "resetToDefault": "Reset to Default",
    "paintBucketSettings": "Paint Bucket Settings",
    "tolerance": "Tolerance",
    "fillOpacity": "Fill Opacity",
    "colorSelectSettings": "Color Select Settings",
    "selectionOpacity": "Selection Opacity",
    "livePreview": "Live Preview",
    "applyToWholeImage": "Apply to Whole Image",
    "method": "Method",
    "stopAtMask": "Stop at mask",
    "maskTolerance": "Mask Tolerance",
    "layers": "Layers",
    "maskLayer": "Mask Layer",
    "maskOpacity": "Mask Opacity",
    "imageLayer": "Image Layer",
    "maskBlendingOptions": "Mask Blending Options",
    "paintLayer": "Paint Layer",
    "baseImageLayer": "Base Image Layer",
    "activateLayer": "Activate Layer",
    "baseLayerPreview": "Base layer preview",
    "black": "Black",
    "white": "White",
    "negative": "Negative"
  },
  "commands": {
    "runWorkflow": "Run workflow",
    "runWorkflowFront": "Run workflow (Queue at front)",
    "run": "Run",
    "execute": "Execute",
    "interrupt": "Cancel current run",
    "refresh": "Refresh node definitions",
    "clipspace": "Open Clipspace",
    "resetView": "Reset canvas view",
    "clear": "Clear workflow",
    "toggleBottomPanel": "Toggle Bottom Panel",
    "theme": "Theme",
    "dark": "Dark",
    "light": "Light",
    "manageExtensions": "Extensions",
    "settings": "Settings",
    "help": "Help",
    "queue": "Queue Panel"
  },
  "queue": {
    "initializingAlmostReady": "Initializing - Almost ready",
    "inQueue": "In queue...",
    "jobAddedToQueue": "Job queued",
    "jobQueueing": "Job queuing",
    "completedIn": "Finished in {duration}",
    "jobMenu": {
      "openAsWorkflowNewTab": "Open as workflow in new tab",
      "openWorkflowNewTab": "Open workflow in new tab",
      "copyJobId": "Copy job ID",
      "cancelJob": "Cancel job",
      "inspectAsset": "Inspect asset",
      "addToCurrentWorkflow": "Add to current workflow",
      "download": "Download",
      "exportWorkflow": "Export workflow",
      "delete": "Delete",
      "deleteAsset": "Delete asset",
      "removeJob": "Remove job",
      "copyErrorMessage": "Copy error message",
      "reportError": "Report error"
    },
    "toggleJobHistory": "Toggle Job History",
    "jobHistory": "Job History",
    "jobList": {
      "undated": "Undated",
      "sortMostRecent": "Most recent",
      "sortTotalGenerationTime": "Total generation time (longest first)",
      "sortComputeHoursUsed": "Compute hours used (most first)"
    },
    "jobDetails": {
      "header": "Job Details",
      "workflow": "Workflow",
      "jobId": "Job ID",
      "queuedAt": "Queued at",
      "queuePosition": "Queue position",
      "timeElapsed": "Time elapsed",
      "estimatedStartIn": "Estimated to start in",
      "estimatedFinishIn": "Estimated to finish in",
      "generatedOn": "Generated on",
      "totalGenerationTime": "Total generation time",
      "computeHoursUsed": "Compute hours used",
      "failedAfter": "Failed after",
      "errorMessage": "Error message",
      "report": "Report",
      "queuePositionValue": "~{count} job ahead of yours | ~{count} jobs ahead of yours",
      "eta": {
        "seconds": "~{count} second | ~{count} seconds",
        "secondsRange": "~{lo}-{hi} seconds",
        "minutes": "~{count} minute | ~{count} minutes",
        "minutesRange": "~{lo}-{hi} minutes"
      }
    }
  },
  "menuLabels": {
    "File": "File",
    "Edit": "Edit",
    "View": "View",
    "Help": "Help",
    "Check for Updates": "Check for Updates",
    "Open Custom Nodes Folder": "Open Custom Nodes Folder",
    "Open Inputs Folder": "Open Inputs Folder",
    "Open Logs Folder": "Open Logs Folder",
    "Open extra_model_paths_yaml": "Open extra_model_paths.yaml",
    "Open Models Folder": "Open Models Folder",
    "Open Outputs Folder": "Open Outputs Folder",
    "Open DevTools": "Open DevTools",
    "Desktop User Guide": "Desktop User Guide",
    "Quit": "Quit",
    "Reinstall": "Reinstall",
    "Restart": "Restart",
    "Open 3D Viewer (Beta) for Selected Node": "Open 3D Viewer (Beta) for Selected Node",
    "Experimental: Browse Model Assets": "Experimental: Browse Model Assets",
    "Browse Templates": "Browse Templates",
    "Copy": "Copy",
    "Delete Selected Items": "Delete Selected Items",
    "Zoom to fit": "Zoom to fit",
    "Lock Canvas": "Lock Canvas",
    "Move Selected Nodes Down": "Move Selected Nodes Down",
    "Move Selected Nodes Left": "Move Selected Nodes Left",
    "Move Selected Nodes Right": "Move Selected Nodes Right",
    "Move Selected Nodes Up": "Move Selected Nodes Up",
    "Paste": "Paste",
    "Paste with Connect": "Paste with Connect",
    "Reset View": "Reset View",
    "Resize Selected Nodes": "Resize Selected Nodes",
    "Select All": "Select All",
    "Node Links": "Node Links",
    "Canvas Toggle Lock": "Canvas Toggle Lock",
    "Minimap": "Minimap",
    "Pin/Unpin Selected Items": "Pin/Unpin Selected Items",
    "Bypass/Unbypass Selected Nodes": "Bypass/Unbypass Selected Nodes",
    "Collapse/Expand Selected Nodes": "Collapse/Expand Selected Nodes",
    "Mute/Unmute Selected Nodes": "Mute/Unmute Selected Nodes",
    "Pin/Unpin Selected Nodes": "Pin/Unpin Selected Nodes",
    "Unlock Canvas": "Unlock Canvas",
    "Zoom In": "Zoom In",
    "Zoom Out": "Zoom Out",
    "Clear Pending Tasks": "Clear Pending Tasks",
    "Clear Workflow": "Clear Workflow",
    "Contact Support": "Contact Support",
    "Show Model Selector (Dev)": "Show Model Selector (Dev)",
    "Duplicate Current Workflow": "Duplicate Current Workflow",
    "Export": "Export",
    "Export (API)": "Export (API)",
    "Convert Selection to Subgraph": "Convert Selection to Subgraph",
    "Edit Subgraph Widgets": "Edit Subgraph Widgets",
    "Exit Subgraph": "Exit Subgraph",
    "Fit Group To Contents": "Fit Group To Contents",
    "Group Selected Nodes": "Group Selected Nodes",
    "Toggle promotion of hovered widget": "Toggle promotion of hovered widget",
    "Unpack the selected Subgraph": "Unpack the selected Subgraph",
    "Convert selected nodes to group node": "Convert selected nodes to group node",
    "Manage group nodes": "Manage group nodes",
    "Ungroup selected group nodes": "Ungroup selected group nodes",
    "About ComfyUI": "About ComfyUI",
    "Comfy-Org Discord": "Comfy-Org Discord",
    "ComfyUI Docs": "ComfyUI Docs",
    "ComfyUI Forum": "ComfyUI Forum",
    "ComfyUI Issues": "ComfyUI Issues",
    "Interrupt": "Interrupt",
    "Load Default Workflow": "Load Default Workflow",
    "Custom Nodes Manager": "Custom Nodes Manager",
    "Custom Nodes (Legacy)": "Custom Nodes (Legacy)",
    "Manager Menu (Legacy)": "Manager Menu (Legacy)",
    "Install Missing Custom Nodes": "Install Missing Custom Nodes",
    "Check for Custom Node Updates": "Check for Custom Node Updates",
    "Decrease Brush Size in MaskEditor": "Decrease Brush Size in MaskEditor",
    "Increase Brush Size in MaskEditor": "Increase Brush Size in MaskEditor",
    "Open Color Picker in MaskEditor": "Open Color Picker in MaskEditor",
    "Mirror Horizontal in MaskEditor": "Mirror Horizontal in MaskEditor",
    "Mirror Vertical in MaskEditor": "Mirror Vertical in MaskEditor",
    "Open Mask Editor for Selected Node": "Open Mask Editor for Selected Node",
    "Rotate Left in MaskEditor": "Rotate Left in MaskEditor",
    "Rotate Right in MaskEditor": "Rotate Right in MaskEditor",
    "Unload Models": "Unload Models",
    "Unload Models and Execution Cache": "Unload Models and Execution Cache",
    "New": "New",
    "Clipspace": "Clipspace",
    "Manager": "Manager",
    "Open": "Open",
    "Publish": "Publish",
    "Job History": "Job History",
    "Queue Prompt": "Queue Prompt",
    "Queue Prompt (Front)": "Queue Prompt (Front)",
    "Queue Selected Output Nodes": "Queue Selected Output Nodes",
    "Redo": "Redo",
    "Refresh Node Definitions": "Refresh Node Definitions",
    "Rename": "Rename",
    "Save": "Save",
    "Save As": "Save As",
    "Show Settings Dialog": "Show Settings Dialog",
    "Set Subgraph Description": "Set Subgraph Description",
    "Set Subgraph Search Aliases": "Set Subgraph Search Aliases",
    "Experimental: Enable AssetAPI": "Experimental: Enable AssetAPI",
    "Canvas Performance": "Canvas Performance",
    "Help Center": "Help Center",
    "Toggle App Mode": "Toggle App Mode",
    "Toggle Queue Panel V2": "Toggle Queue Panel V2",
    "Toggle Theme (Dark/Light)": "Toggle Theme (Dark/Light)",
    "Undo": "Undo",
    "Open Sign In Dialog": "Open Sign In Dialog",
    "Sign Out": "Sign Out",
    "Experimental: Enable Nodes 2_0": "Experimental: Enable Nodes 2.0",
    "Close Current Workflow": "Close Current Workflow",
    "Next Opened Workflow": "Next Opened Workflow",
    "Previous Opened Workflow": "Previous Opened Workflow",
    "Toggle Search Box": "Toggle Search Box",
    "Bottom Panel": "Bottom Panel",
    "Show Keybindings Dialog": "Show Keybindings Dialog",
    "Toggle Terminal Bottom Panel": "Toggle Terminal Bottom Panel",
    "Toggle Logs Bottom Panel": "Toggle Logs Bottom Panel",
    "Toggle Essential Bottom Panel": "Toggle Essential Bottom Panel",
    "Toggle View Controls Bottom Panel": "Toggle View Controls Bottom Panel",
    "Focus Mode": "Focus Mode",
    "linearMode_appModeToolbar_apps": "linearMode.appModeToolbar.apps",
    "Assets": "Assets",
    "Model Library": "Model Library",
    "Node Library": "Node Library",
    "Workflows": "Workflows"
  },
  "desktopMenu": {
    "reinstall": "Reinstall",
    "confirmReinstall": "This will clear your extra_models_config.yaml file,\nand begin installation again.\n\nAre you sure?",
    "quit": "Quit",
    "confirmQuit": "There are unsaved workflows open; any unsaved changes will be lost.  Ignore this and quit?"
  },
  "settingsCategories": {
    "Comfy-Desktop": "Comfy-Desktop",
    "General": "General",
    "Appearance": "Appearance",
    "ColorPalette": "Color Palette",
    "Comfy": "Comfy",
    "Workflow": "Workflow",
    "DevMode": "Dev Mode",
    "LiteGraph": "Lite Graph",
    "Node Widget": "Node Widget",
    "Node": "Node",
    "Extension": "Extension",
    "Canvas": "Canvas",
    "Link": "Link",
    "Group": "Group",
    "Menu": "Menu",
    "Keybinding": "Keybinding",
    "LinkRelease": "Link Release",
    "Graph": "Graph",
    "Locale": "Locale",
    "Mask Editor": "Mask Editor",
    "BrushAdjustment": "Brush Adjustment",
    "ModelLibrary": "Model Library",
    "NodeLibrary": "Node Library",
    "Node Search Box": "Node Search Box",
    "Pointer": "Pointer",
    "Queue": "Queue",
    "QueueButton": "Queue Button",
    "RerouteBeta": "Reroute Beta",
    "Server": "Server",
    "Settings": "Settings",
    "Sidebar": "Sidebar",
    "Tree Explorer": "Tree Explorer",
    "Validation": "Validation",
    "Window": "Window",
    "Server-Config": "Server-Config",
    "About": "About",
    "EditTokenWeight": "Edit Token Weight",
    "CustomColorPalettes": "Custom Color Palettes",
    "UV": "UV",
    "ContextMenu": "Context Menu",
    "Reroute": "Reroute",
    "Load 3D": "Load 3D & Animation",
    "Camera": "Camera",
    "Scene": "Scene",
    "3D": "3D",
    "Light": "Light",
    "User": "User",
    "Credits": "Credits",
    "API Nodes": "API Nodes",
    "Notification Preferences": "Notification Preferences",
    "3DViewer": "3DViewer",
    "Canvas Navigation": "Canvas Navigation",
    "PlanCredits": "Plan & Credits",
    "Vue Nodes": "Nodes 2.0",
    "VueNodes": "Nodes 2.0",
    "Nodes 2_0": "Nodes 2.0",
    "Execution": "Execution",
    "PLY": "PLY",
    "Workspace": "Workspace",
    "Error System": "Error System",
    "Other": "Other",
    "Secrets": "Secrets",
    "Node Library": "Node Library"
  },
  "serverConfigItems": {
    "listen": {
      "name": "Host: The IP address to listen on"
    },
    "port": {
      "name": "Port: The port to listen on"
    },
    "tls-keyfile": {
      "name": "TLS Key File: Path to TLS key file for HTTPS"
    },
    "tls-certfile": {
      "name": "TLS Certificate File: Path to TLS certificate file for HTTPS"
    },
    "enable-cors-header": {
      "name": "Enable CORS header: Use \"*\" for all origins or specify domain"
    },
    "max-upload-size": {
      "name": "Maximum upload size (MB)"
    },
    "cuda-device": {
      "name": "CUDA device index to use"
    },
    "cuda-malloc": {
      "name": "Use CUDA malloc for memory allocation"
    },
    "global-precision": {
      "name": "Global floating point precision",
      "tooltip": "Global floating point precision"
    },
    "unet-precision": {
      "name": "UNET precision",
      "tooltip": "UNET precision"
    },
    "vae-precision": {
      "name": "VAE precision",
      "tooltip": "VAE precision"
    },
    "cpu-vae": {
      "name": "Run VAE on CPU"
    },
    "text-encoder-precision": {
      "name": "Text Encoder precision",
      "tooltip": "Text Encoder precision"
    },
    "force-channels-last": {
      "name": "Force channels-last memory format"
    },
    "directml": {
      "name": "DirectML device index"
    },
    "disable-ipex-optimize": {
      "name": "Disable IPEX optimization"
    },
    "preview-method": {
      "name": "Method used for latent previews"
    },
    "preview-size": {
      "name": "Size of preview images"
    },
    "cache-classic": {
      "name": "Use classic cache system"
    },
    "cache-lru": {
      "name": "Use LRU caching with a maximum of N node results cached.",
      "tooltip": "May use more RAM/VRAM."
    },
    "cross-attention-method": {
      "name": "Cross attention method"
    },
    "disable-xformers": {
      "name": "Disable xFormers optimization"
    },
    "force-upcast-attention": {
      "name": "Force attention upcast"
    },
    "dont-upcast-attention": {
      "name": "Prevent attention upcast"
    },
    "vram-management": {
      "name": "VRAM management mode"
    },
    "reserve-vram": {
      "name": "Reserved VRAM (GB)",
      "tooltip": "Set the amount of vram in GB you want to reserve for use by your OS/other software. By default some amount is reserved depending on your OS."
    },
    "default-hashing-function": {
      "name": "Default hashing function for model files"
    },
    "disable-smart-memory": {
      "name": "Disable smart memory management",
      "tooltip": "Force ComfyUI to aggressively offload to regular ram instead of keeping models in vram when it can."
    },
    "deterministic": {
      "name": "Make pytorch use slower deterministic algorithms when it can.",
      "tooltip": "Note that this might not make images deterministic in all cases."
    },
    "fast": {
      "name": "Enable some untested and potentially quality deteriorating optimizations."
    },
    "dont-print-server": {
      "name": "Don't print server output to console."
    },
    "disable-metadata": {
      "name": "Disable saving prompt metadata in files."
    },
    "enable-manager-legacy-ui": {
      "name": "Use legacy Manager UI",
      "tooltip": "Uses the legacy ComfyUI-Manager UI instead of the new UI."
    },
    "disable-all-custom-nodes": {
      "name": "Disable loading all custom nodes."
    },
    "log-level": {
      "name": "Logging verbosity level"
    },
    "input-directory": {
      "name": "Input directory"
    },
    "output-directory": {
      "name": "Output directory"
    }
  },
  "serverConfigCategories": {
    "Network": "Network",
    "CUDA": "CUDA",
    "Inference": "Inference",
    "Memory": "Memory",
    "Preview": "Preview",
    "Cache": "Cache",
    "Attention": "Attention",
    "General": "General",
    "Directories": "Directories"
  },
  "nodeCategories": {
    "_for_testing": "_for_testing",
    "custom_sampling": "custom_sampling",
    "noise": "noise",
    "dataset": "dataset",
    "text": "text",
    "image": "image",
    "sampling": "sampling",
    "schedulers": "schedulers",
    "audio": "audio",
    "conditioning": "conditioning",
    "loaders": "loaders",
    "guiders": "guiders",
    "batch": "batch",
    "latent": "latent",
    "mask": "mask",
    "api node": "api node",
    "Bria": "Bria",
    "video": "video",
    "ByteDance": "ByteDance",
    "preprocessors": "preprocessors",
    "advanced": "advanced",
    "guidance": "guidance",
    "model_merging": "model_merging",
    "model_patches": "model_patches",
    "chroma_radiance": "chroma_radiance",
    "attention_experiments": "attention_experiments",
    "flux": "flux",
    "kandinsky5": "kandinsky5",
    "utils": "utils",
    "postprocessing": "postprocessing",
    "hooks": "hooks",
    "combine": "combine",
    "math": "math",
    "logic": "logic",
    "cond single": "cond single",
    "context": "context",
    "controlnet": "controlnet",
    "inpaint": "inpaint",
    "scheduling": "scheduling",
    "create": "create",
    "deprecated": "deprecated",
    "detection": "detection",
    "": "",
    "debug": "debug",
    "model": "model",
    "ElevenLabs": "ElevenLabs",
    "3d": "3d",
    "ltxv": "ltxv",
    "qwen": "qwen",
    "sd3": "sd3",
    "unet": "unet",
    "sigmas": "sigmas",
    "BFL": "BFL",
    "Gemini": "Gemini",
    "video_models": "video_models",
    "gligen": "gligen",
    "shader": "shader",
    "Grok": "Grok",
    "Wan": "Wan",
    "HitPaw": "HitPaw",
    "sd": "sd",
    "Ideogram": "Ideogram",
    "transform": "transform",
    "color": "color",
    "upscaling": "upscaling",
    "instructpix2pix": "instructpix2pix",
    "compositing": "compositing",
    "Kling": "Kling",
    "samplers": "samplers",
    "operations": "operations",
    "training": "training",
    "lotus": "lotus",
    "LTXV": "LTXV",
    "Luma": "Luma",
    "Magnific": "Magnific",
    "Meshy": "Meshy",
    "MiniMax": "MiniMax",
    "model_specific": "model_specific",
    "OpenAI": "OpenAI",
    "Sora": "Sora",
    "cond pair": "cond pair",
    "photomaker": "photomaker",
    "PixVerse": "PixVerse",
    "primitive": "primitive",
    "Quiver": "Quiver",
    "Recraft": "Recraft",
    "edit_models": "edit_models",
    "Reve": "Reve",
    "Rodin": "Rodin",
    "Runway": "Runway",
    "animation": "animation",
    "api": "api",
    "save": "save",
    "upscale_diffusion": "upscale_diffusion",
    "clip": "clip",
    "Sonilo": "Sonilo",
    "Stability AI": "Stability AI",
    "stable_cascade": "stable_cascade",
    "3d_models": "3d_models",
    "style_model": "style_model",
    "supir": "supir",
    "Tencent": "Tencent",
    "textgen": "textgen",
    "Topaz": "Topaz",
    "Tripo": "Tripo",
    "Veo": "Veo",
    "Vidu": "Vidu",
    "camera": "camera",
    "WaveSpeed": "WaveSpeed",
    "zimage": "zimage"
  },
  "dataTypes": {
    "*": "*",
    "AUDIO": "AUDIO",
    "AUDIO_ENCODER": "AUDIO_ENCODER",
    "AUDIO_ENCODER_OUTPUT": "AUDIO_ENCODER_OUTPUT",
    "AUDIO_RECORD": "AUDIO_RECORD",
    "BOOLEAN": "BOOLEAN",
    "BOUNDING_BOX": "BOUNDING_BOX",
    "CAMERA_CONTROL": "CAMERA_CONTROL",
    "CLIP": "CLIP",
    "CLIP_VISION": "CLIP_VISION",
    "CLIP_VISION_OUTPUT": "CLIP_VISION_OUTPUT",
    "COLOR": "COLOR",
    "COMBO": "COMBO",
    "COMFY_AUTOGROW_V3": "COMFY_AUTOGROW_V3",
    "COMFY_DYNAMICCOMBO_V3": "COMFY_DYNAMICCOMBO_V3",
    "COMFY_MATCHTYPE_V3": "COMFY_MATCHTYPE_V3",
    "CONDITIONING": "CONDITIONING",
    "CONTROL_NET": "CONTROL_NET",
    "CURVE": "CURVE",
    "ELEVENLABS_VOICE": "ELEVENLABS_VOICE",
    "FILE_3D": "FILE_3D",
    "FILE_3D_FBX": "FILE_3D_FBX",
    "FILE_3D_GLB": "FILE_3D_GLB",
    "FILE_3D_GLTF": "FILE_3D_GLTF",
    "FILE_3D_OBJ": "FILE_3D_OBJ",
    "FILE_3D_STL": "FILE_3D_STL",
    "FILE_3D_USDZ": "FILE_3D_USDZ",
    "FLOAT": "FLOAT",
    "FLOATS": "FLOATS",
    "GEMINI_INPUT_FILES": "GEMINI_INPUT_FILES",
    "GLIGEN": "GLIGEN",
    "GUIDER": "GUIDER",
    "HISTOGRAM": "HISTOGRAM",
    "HOOK_KEYFRAMES": "HOOK_KEYFRAMES",
    "HOOKS": "HOOKS",
    "IMAGE": "IMAGE",
    "IMAGECOMPARE": "IMAGECOMPARE",
    "INT": "INT",
    "INTERP_MODEL": "INTERP_MODEL",
    "LATENT": "LATENT",
    "LATENT_OPERATION": "LATENT_OPERATION",
    "LATENT_UPSCALE_MODEL": "LATENT_UPSCALE_MODEL",
    "LOAD_3D": "LOAD_3D",
    "LOAD3D_CAMERA": "LOAD3D_CAMERA",
    "LORA_MODEL": "LORA_MODEL",
    "LOSS_MAP": "LOSS_MAP",
    "LUMA_CONCEPTS": "LUMA_CONCEPTS",
    "LUMA_REF": "LUMA_REF",
    "MASK": "MASK",
    "MESH": "MESH",
    "MESHY_RIGGED_TASK_ID": "MESHY_RIGGED_TASK_ID",
    "MESHY_TASK_ID": "MESHY_TASK_ID",
    "MODEL": "MODEL",
    "MODEL_PATCH": "MODEL_PATCH",
    "MODEL_TASK_ID": "MODEL_TASK_ID",
    "NOISE": "NOISE",
    "OPENAI_CHAT_CONFIG": "OPENAI_CHAT_CONFIG",
    "OPENAI_INPUT_FILES": "OPENAI_INPUT_FILES",
    "PHOTOMAKER": "PHOTOMAKER",
    "PIXVERSE_TEMPLATE": "PIXVERSE_TEMPLATE",
    "POSE_KEYPOINT": "POSE_KEYPOINT",
    "RECRAFT_COLOR": "RECRAFT_COLOR",
    "RECRAFT_CONTROLS": "RECRAFT_CONTROLS",
    "RECRAFT_V3_STYLE": "RECRAFT_V3_STYLE",
    "RETARGET_TASK_ID": "RETARGET_TASK_ID",
    "RIG_TASK_ID": "RIG_TASK_ID",
    "SAM3_TRACK_DATA": "SAM3_TRACK_DATA",
    "SAMPLER": "SAMPLER",
    "SIGMAS": "SIGMAS",
    "STRING": "STRING",
    "STYLE_MODEL": "STYLE_MODEL",
    "SVG": "SVG",
    "TIMESTEPS_RANGE": "TIMESTEPS_RANGE",
    "TRACKS": "TRACKS",
    "UPSCALE_MODEL": "UPSCALE_MODEL",
    "VAE": "VAE",
    "VIDEO": "VIDEO",
    "VOXEL": "VOXEL",
    "WAN_CAMERA_EMBEDDING": "WAN_CAMERA_EMBEDDING",
    "WEBCAM": "WEBCAM"
  },
  "maintenance": {
    "title": "Maintenance",
    "allOk": "No issues were detected.",
    "status": "Status",
    "detected": "Detected",
    "refreshing": "Refreshing",
    "None": "None",
    "OK": "OK",
    "Skipped": "Skipped",
    "showManual": "Show maintenance tasks",
    "confirmTitle": "Are you sure?",
    "terminalDefaultMessage": "When you run a troubleshooting command, any output will be shown here.",
    "consoleLogs": "Console Logs",
    "error": {
      "toastTitle": "Task error",
      "taskFailed": "Task failed to run.",
      "cannotContinue": "Unable to continue - errors remain",
      "defaultDescription": "An error occurred while running a maintenance task."
    },
    "unsafeMigration": {
      "title": "Unsafe install location detected",
      "generic": "Your current ComfyUI base path is in a location that may be deleted or modified during updates. To avoid data loss, move it to a safe folder.",
      "appInstallDir": "Your base path is inside the ComfyUI Desktop application bundle. This folder may be deleted or overwritten during updates. Choose a directory outside the install folder, such as Documents/ComfyUI.",
      "updaterCache": "Your base path is inside the ComfyUI updater cache, which is cleared on each update. Choose a different location for your data.",
      "oneDrive": "Your base path is on OneDrive, which can cause sync issues and accidental data loss. Choose a local folder that is not managed by OneDrive.",
      "action": "Use the \"Base path\" maintenance task below to move ComfyUI to a safe location."
    }
  },
  "missingModelsDialog": {
    "doNotAskAgain": "Don't show this again",
    "reEnableInSettings": "Re-enable in {link}",
    "reEnableInSettingsLink": "Settings",
    "title": "This workflow is missing models",
    "description": "This workflow requires models you haven't downloaded yet.",
    "totalSize": "Total download size:",
    "downloadAll": "Download all",
    "downloadAvailable": "Download available",
    "gotIt": "Ok, got it",
    "footerDescription": "Download and place these models in the correct folder.\nNodes with missing models are highlighted red on the canvas.",
    "customModelsWarning": "Some of these are custom models that we don't recognize.",
    "customModelsInstruction": "You'll need to find and download them manually. Search for them online (try Civitai or HuggingFace) or contact the original workflow provider.",
    "acceptTerms": "Accept terms"
  },
  "versionMismatchWarning": {
    "title": "Version Compatibility Warning",
    "frontendOutdated": "Frontend version {frontendVersion} is outdated. Backend requires version {requiredVersion} or higher.",
    "frontendNewer": "Frontend version {frontendVersion} may not be compatible with backend version {backendVersion}.",
    "updateFrontend": "Update Frontend",
    "dismiss": "Dismiss"
  },
  "loadWorkflowWarning": {
    "outdatedVersion": "This workflow was created with a newer version of ComfyUI ({version}). Some nodes may not work correctly.",
    "outdatedVersionGeneric": "This workflow was created with a newer version of ComfyUI. Some nodes may not work correctly.",
    "coreNodesFromVersion": "Core nodes from version {version}:",
    "unknownVersion": "unknown"
  },
  "errorDialog": {
    "defaultTitle": "An error occurred",
    "loadWorkflowTitle": "Loading aborted due to error reloading workflow data",
    "noStackTrace": "No stacktrace available",
    "extensionFileHint": "This may be due to the following script",
    "promptExecutionError": "Prompt execution failed",
    "accessRestrictedTitle": "Access Restricted",
    "accessRestrictedMessage": "Your account is not authorized for this feature."
  },
  "apiNodesSignInDialog": {
    "title": "Sign In Required to Use API Nodes",
    "message": "This workflow contains API Nodes, which require you to be signed in to your account in order to run."
  },
  "apiNodesCostBreakdown": {
    "title": "API Node(s)",
    "costPerRun": "Cost per run",
    "totalCost": "Total Cost"
  },
  "desktopUpdate": {
    "title": "Updating ComfyUI Desktop",
    "description": "ComfyUI Desktop is installing new dependencies.  This may take a few minutes.",
    "terminalDefaultMessage": "Any console output from the update will be shown here.",
    "updateFoundTitle": "Update Found (v{version})",
    "updateAvailableMessage": "An update is available. Do you want to restart and update now?",
    "noUpdateFound": "No update found",
    "errorCheckingUpdate": "Error checking for updates",
    "errorInstallingUpdate": "Error installing update"
  },
  "clipboard": {
    "successMessage": "Copied to clipboard",
    "errorMessage": "Failed to copy to clipboard",
    "errorNotSupported": "Clipboard API not supported in your browser"
  },
  "imageCompare": {
    "noImages": "No images to compare",
    "batchLabelA": "A:",
    "batchLabelB": "B:"
  },
  "batch": {
    "index": "{current} / {total}"
  },
  "load3d": {
    "switchCamera": "Switch Camera",
    "showGrid": "Show Grid",
    "backgroundColor": "Background Color",
    "lightIntensity": "Light Intensity",
    "fov": "FOV",
    "previewOutput": "Preview Output",
    "uploadBackgroundImage": "Upload Background Image",
    "removeBackgroundImage": "Remove Background Image",
    "tiledMode": "Tiled",
    "panoramaMode": "Panorama",
    "loadingModel": "Loading 3D Model...",
    "upDirection": "Up Direction",
    "materialMode": "Material Mode",
    "showSkeleton": "Show Skeleton",
    "fitToViewer": "Fit to Viewer",
    "scene": "Scene",
    "model": "Model",
    "camera": "Camera",
    "light": "Light",
    "switchingMaterialMode": "Switching Material Mode...",
    "edgeThreshold": "Edge Threshold",
    "export": "Export",
    "exportModel": "Export Model",
    "exportingModel": "Exporting model...",
    "reloadingModel": "Reloading model...",
    "uploadTexture": "Upload Texture",
    "applyingTexture": "Applying Texture...",
    "materialModes": {
      "normal": "Normal",
      "wireframe": "Wireframe",
      "original": "Original",
      "pointCloud": "Point Cloud",
      "depth": "Depth",
      "lineart": "Lineart"
    },
    "upDirections": {
      "original": "Original"
    },
    "startRecording": "Start Recording",
    "stopRecording": "Stop Recording",
    "exportRecording": "Export Recording",
    "clearRecording": "Clear Recording",
    "resizeNodeMatchOutput": "Resize Node to match output",
    "loadingBackgroundImage": "Loading Background Image",
    "cameraType": {
      "perspective": "Perspective",
      "orthographic": "Orthographic"
    },
    "viewer": {
      "title": "3D Viewer (Beta)",
      "apply": "Apply",
      "cancel": "Cancel",
      "cameraType": "Camera Type",
      "sceneSettings": "Scene Settings",
      "cameraSettings": "Camera Settings",
      "lightSettings": "Light Settings",
      "exportSettings": "Export Settings",
      "modelSettings": "Model Settings"
    },
    "openIn3DViewer": "Open in 3D Viewer",
    "dropToLoad": "Drop 3D model to load",
    "unsupportedFileType": "Unsupported file type (supports .gltf, .glb, .obj, .fbx, .stl, .ply, .spz, .splat, .ksplat)",
    "uploadingModel": "Uploading 3D model...",
    "loadingHDRI": "Loading HDRI...",
    "hdri": {
      "label": "HDRI Environment",
      "uploadFile": "Upload HDRI (.hdr, .exr)",
      "changeFile": "Change HDRI",
      "removeFile": "Remove HDRI",
      "showAsBackground": "Show as Background",
      "intensity": "Intensity"
    },
    "gizmo": {
      "label": "Gizmo",
      "toggle": "Gizmo",
      "translate": "Translate",
      "rotate": "Rotate",
      "scale": "Scale",
      "reset": "Reset Transform"
    }
  },
  "imageCrop": {
    "loading": "Loading...",
    "noInputImage": "No input image connected",
    "cropPreviewAlt": "Crop preview",
    "ratio": "Ratio",
    "lockRatio": "Lock aspect ratio",
    "unlockRatio": "Unlock aspect ratio",
    "custom": "Custom"
  },
  "painter": {
    "tool": "Tool",
    "brush": "Brush",
    "eraser": "Eraser",
    "size": "Cursor Size",
    "color": "Color Picker",
    "hardness": "Hardness",
    "width": "Width",
    "height": "Height",
    "background": "Background",
    "clear": "Clear",
    "uploadError": "Failed to upload painter image: {status} - {statusText}"
  },
  "boundingBox": {
    "x": "X",
    "y": "Y",
    "width": "Width",
    "height": "Height"
  },
  "curveWidget": {
    "monotone_cubic": "Smooth",
    "linear": "Linear"
  },
  "toastMessages": {
    "nothingToQueue": "Nothing to queue",
    "pleaseSelectOutputNodes": "Please select output nodes",
    "failedToQueue": "Failed to queue",
    "failedToSaveDraft": "Failed to save workflow draft",
    "failedExecutionPathResolution": "Could not resolve path to selected nodes",
    "no3dScene": "No 3D scene to apply texture",
    "failedToApplyTexture": "Failed to apply texture",
    "no3dSceneToExport": "No 3D scene to export",
    "failedToExportModel": "Failed to export model as {format}",
    "exportSuccess": "Successfully exported model as {format}",
    "fileLoadError": "Unable to find workflow in {fileName}",
    "dropFileError": "Unable to process dropped item: {error}",
    "missingModelVerificationFailed": "Failed to verify missing models. Some models may not be shown in the Errors tab.",
    "interrupted": "Execution has been interrupted",
    "pendingTasksDeleted": "Pending tasks deleted",
    "nothingToGroup": "Nothing to group",
    "pleaseSelectNodesToGroup": "Please select the nodes (or other groups) to create a group for",
    "emptyCanvas": "Empty canvas",
    "fileUploadFailed": "File upload failed",
    "fileTooLarge": "File too large ({size} MB). Maximum supported size is {maxSize} MB",
    "unableToGetModelFilePath": "Unable to get model file path",
    "couldNotDetermineFileType": "Could not determine file type",
    "errorLoadingModel": "Error loading model",
    "failedToDownloadFile": "Failed to download file",
    "updateRequested": "Update requested",
    "nodeDefinitionsUpdated": "Node definitions updated",
    "nodeDefinitionsUpdateFailed": "Failed to update node definitions",
    "errorSaveSetting": "Error saving setting {id}: {err}",
    "errorCopyImage": "Error copying image: {error}",
    "errorOpenImage": "Error opening image: {error}",
    "noTemplatesToExport": "No templates to export",
    "failedToFetchLogs": "Failed to fetch server logs",
    "migrateToLitegraphReroute": "Reroute nodes will be removed in future versions. Click to migrate to litegraph-native reroute.",
    "legacyMaskEditorDeprecated": "The legacy mask editor is deprecated and will be removed soon.",
    "userNotAuthenticated": "User not authenticated",
    "failedToFetchBalance": "Failed to fetch balance: {error}",
    "failedToCreateCustomer": "Failed to create customer: {error}",
    "failedToInitiateCreditPurchase": "Failed to initiate credit purchase: {error}",
    "failedToAccessBillingPortal": "Failed to access billing portal: {error}",
    "failedToPurchaseCredits": "Failed to purchase credits: {error}",
    "failedToFetchSubscription": "Failed to fetch subscription status: {error}",
    "failedToInitiateSubscription": "Failed to initiate subscription: {error}",
    "unauthorizedDomain": "Your domain {domain} is not authorized to use this service. Please contact {email} to add your domain to the whitelist.",
    "useApiKeyTip": "Tip: Can't access normal login? Use the Comfy API Key option.",
    "nothingSelected": "Nothing selected",
    "cannotCreateSubgraph": "Cannot create subgraph",
    "failedToConvertToSubgraph": "Failed to convert items to subgraph",
    "failedToInitializeLoad3dViewer": "Failed to initialize 3D Viewer",
    "failedToLoadBackgroundImage": "Failed to load background image",
    "failedToLoadModel": "Failed to load 3D model",
    "modelLoadedSuccessfully": "3D model loaded successfully",
    "failedToUpdateBackgroundColor": "Failed to update background color",
    "failedToToggleGrid": "Failed to toggle grid",
    "failedToToggleCamera": "Failed to toggle camera",
    "failedToUpdateFOV": "Failed to update field of view",
    "failedToUpdateLightIntensity": "Failed to update light intensity",
    "failedToUpdateBackgroundImage": "Failed to update background image",
    "failedToUpdateUpDirection": "Failed to update up direction",
    "failedToUpdateMaterialMode": "Failed to update material mode",
    "failedToUpdateEdgeThreshold": "Failed to update edge threshold",
    "failedToUploadBackgroundImage": "Failed to upload background image",
    "failedToUpdateBackgroundRenderMode": "Failed to update background render mode to {mode}",
    "failedToLoadHDRI": "Failed to load HDRI file",
    "unsupportedHDRIFormat": "Unsupported file format. Please upload a .hdr or .exr file.",
    "failedToToggleGizmo": "Failed to toggle gizmo",
    "failedToSetGizmoMode": "Failed to set gizmo mode"
  },
  "nodeErrors": {
    "render": "Node Render Error",
    "content": "Node Content Error",
    "header": "Node Header Error",
    "slots": "Node Slots Error",
    "widgets": "Node Widgets Error"
  },
  "auth": {
    "apiKey": {
      "title": "API Key",
      "label": "API Key",
      "description": "Use your Comfy API key to enable API Nodes",
      "placeholder": "Enter your API Key",
      "error": "Invalid API Key",
      "storageFailed": "Failed to store API Key",
      "storageFailedDetail": "Please try again.",
      "stored": "API Key stored",
      "storedDetail": "Your API Key has been stored successfully",
      "cleared": "API Key cleared",
      "clearedDetail": "Your API Key has been cleared successfully",
      "invalid": "Invalid API Key",
      "invalidDetail": "Please enter a valid API Key",
      "helpText": "Need an API key?",
      "generateKey": "Get one here",
      "whitelistInfo": "About non-whitelisted sites"
    },
    "login": {
      "title": "Log in to your account",
      "useApiKey": "Comfy API Key",
      "signInOrSignUp": "Sign In / Sign Up",
      "forgotPasswordError": "Failed to send password reset email",
      "passwordResetSent": "Password reset email sent",
      "passwordResetSentDetail": "Please check your email for a link to reset your password.",
      "newUser": "New here?",
      "userAvatar": "User Avatar",
      "signUp": "Sign up",
      "signUpFreeTierPromo": "New here? {signUp} with Google to get {credits} free credits every month.",
      "emailLabel": "Email",
      "emailPlaceholder": "Enter your email",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Enter your password",
      "confirmPasswordLabel": "Confirm Password",
      "confirmPasswordPlaceholder": "Enter the same password again",
      "forgotPassword": "Forgot password?",
      "passwordResetInstructions": "Enter your email address and we'll send you a link to reset your password.",
      "sendResetLink": "Send reset link",
      "backToLogin": "Back to login",
      "didntReceiveEmail": "Didn't receive an email? Contact us at",
      "passwordResetError": "Failed to send password reset email. Please try again.",
      "loginButton": "Sign in",
      "orContinueWith": "Or continue with",
      "loginWithGoogle": "Log in with Google",
      "loginWithGithub": "Log in with Github",
      "termsText": "By clicking \"Next\" or \"Sign Up\", you agree to our",
      "termsLink": "Terms of Use",
      "andText": "and",
      "privacyLink": "Privacy Policy",
      "success": "Login successful",
      "failed": "Login failed",
      "insecureContextWarning": "This connection is insecure (HTTP) - your credentials may be intercepted by attackers if you proceed to login.",
      "questionsContactPrefix": "Questions? Contact us at",
      "noAssociatedUser": "There is no Comfy user associated with the provided API key",
      "useEmailInstead": "Use email instead",
      "freeTierBadge": "Eligible for Free Tier",
      "freeTierDescription": "Sign up with Google to get {credits} free credits every month. No card needed.",
      "freeTierDescriptionGeneric": "Sign up with Google to get free credits every month. No card needed.",
      "backToSocialLogin": "Sign up with Google or Github instead",
      "backToGithubLogin": "Sign up with Github instead"
    },
    "signup": {
      "title": "Create an account",
      "alreadyHaveAccount": "Already have an account?",
      "emailLabel": "Email",
      "emailPlaceholder": "Enter your email",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Enter new password",
      "signUpButton": "Sign up",
      "signIn": "Sign in",
      "signUpWithGoogle": "Sign up with Google",
      "signUpWithGithub": "Sign up with Github",
      "regionRestrictionChina": "In accordance with local regulatory requirements, our services are temporarily unavailable to users located in China.",
      "personalDataConsentLabel": "I agree to the processing of my personal data.",
      "emailNotEligibleForFreeTier": "Email sign-up is not eligible for Free Tier."
    },
    "signOut": {
      "signOut": "Log Out",
      "success": "Signed out successfully",
      "successDetail": "You have been signed out of your account.",
      "unsavedChangesTitle": "Unsaved Changes",
      "unsavedChangesMessage": "You have unsaved changes that will be lost when you sign out. Do you want to continue?",
      "signOutAnyway": "Sign out anyway",
      "saveFailed": "Sign-out cancelled because saving \"{workflow}\" failed."
    },
    "passwordUpdate": {
      "success": "Password Updated",
      "successDetail": "Your password has been updated successfully"
    },
    "errors": {
      "auth/invalid-email": "Please enter a valid email address.",
      "auth/user-disabled": "This account has been disabled. Please contact support.",
      "auth/user-not-found": "No account found with this email. Would you like to create a new account?",
      "auth/wrong-password": "The password you entered is incorrect. Please try again.",
      "auth/email-already-in-use": "An account with this email already exists. Try signing in instead.",
      "auth/weak-password": "Password is too weak. Please use a stronger password with at least 6 characters.",
      "auth/too-many-requests": "Too many login attempts. Please wait a moment and try again.",
      "auth/operation-not-allowed": "This sign-in method is not currently supported.",
      "auth/invalid-credential": "Invalid login credentials. Please check your email and password.",
      "auth/network-request-failed": "Network error. Please check your connection and try again.",
      "auth/popup-closed-by-user": "Sign-in was cancelled. Please try again.",
      "auth/cancelled-popup-request": "Sign-in was cancelled. Please try again."
    },
    "deleteAccount": {
      "contactSupport": "To delete your account, please contact {email}"
    },
    "reauthRequired": {
      "title": "Re-authentication Required",
      "message": "For security reasons, this action requires you to sign in again. Would you like to proceed?",
      "confirm": "Sign In Again",
      "cancel": "Cancel"
    },
    "loginButton": {
      "tooltipHelp": "Login to be able to use \"API Nodes\"",
      "tooltipLearnMore": "Learn more..."
    }
  },
  "validation": {
    "invalidEmail": "Invalid email address",
    "required": "Required",
    "minLength": "Must be at least {length} characters",
    "maxLength": "Must be no more than {length} characters",
    "prefix": "Must start with {prefix}",
    "descriptionRequired": "Description is required",
    "length": "Must be {length} characters",
    "password": {
      "requirements": "Password requirements",
      "minLength": "Must be between 8 and 32 characters",
      "uppercase": "Must contain at least one uppercase letter",
      "lowercase": "Must contain at least one lowercase letter",
      "number": "Must contain at least one number",
      "special": "Must contain at least one special character",
      "match": "Passwords must match"
    },
    "personalDataConsentRequired": "You must agree to the processing of your personal data."
  },
  "credits": {
    "activity": "Activity",
    "credits": "Credits",
    "yourCreditBalance": "Your credit balance",
    "purchaseCredits": "Purchase Credits",
    "invoiceHistory": "Invoice History",
    "apiPricing": "API Pricing",
    "faqs": "FAQs",
    "messageSupport": "Message Support",
    "lastUpdated": "Last updated",
    "topUp": {
      "insufficientTitle": "Insufficient Credits",
      "insufficientMessage": "You don't have enough credits to run this workflow.",
      "quickPurchase": "Quick Purchase",
      "maxAmount": "(Max. $1,000 USD)",
      "buyNow": "Buy now",
      "seeDetails": "See details",
      "topUp": "Top Up",
      "addMoreCredits": "Add more credits",
      "addMoreCreditsToRun": "Add more credits to run",
      "insufficientWorkflowMessage": "You don't have enough credits to run this workflow.",
      "creditsDescription": "Credits are used to run workflows or partner nodes.",
      "howManyCredits": "How many credits would you like to add?",
      "usdAmount": "${amount}",
      "videosEstimate": "~{count} videos*",
      "templateNote": "*Generated with Wan 2.2 Image-to-Video template",
      "buy": "Buy",
      "purchaseSuccess": "Credits added successfully!",
      "purchaseError": "Purchase Failed",
      "purchaseErrorDetail": "Failed to purchase credits: {error}",
      "unknownError": "An unknown error occurred",
      "viewPricing": "View pricing details",
      "youPay": "Amount (USD)",
      "youGet": "Credits",
      "buyCredits": "Continue to payment",
      "minimumPurchase": "${amount} minimum ({credits} credits)",
      "maximumAmount": "${amount} max.",
      "minRequired": "{credits} credits minimum",
      "maxAllowed": "{credits} credits maximum.",
      "creditsPerDollar": "credits per dollar",
      "amountToPayLabel": "Amount to pay in dollars",
      "creditsToReceiveLabel": "Credits to receive",
      "selectAmount": "Select amount",
      "needMore": "Need more?",
      "contactUs": "Contact us"
    },
    "creditsAvailable": "Credits available",
    "refreshes": "Refreshes {date}",
    "eventType": "Event Type",
    "details": "Details",
    "time": "Time",
    "additionalInfo": "Additional Info",
    "model": "Model",
    "added": "Added",
    "accountInitialized": "Account initialized",
    "unified": {
      "message": "Credits have been unified",
      "tooltip": "We've unified payments across Comfy. Everything now runs on Comfy Credits:\n- Partner Nodes (formerly API nodes)\n- Cloud workflows\n\nYour existing Partner node balance has been converted into credits."
    }
  },
  "billingOperation": {
    "subscriptionProcessing": "Processing payment — setting up your workspace...",
    "subscriptionSuccess": "Subscription updated successfully",
    "subscriptionFailed": "Subscription update failed",
    "subscriptionTimeout": "Subscription verification timed out",
    "topupProcessing": "Processing payment — adding credits...",
    "topupSuccess": "Credits added successfully",
    "topupFailed": "Top-up failed",
    "topupTimeout": "Top-up verification timed out"
  },
  "subscription": {
    "plansForWorkspace": "Plans for {workspace}",
    "personalWorkspace": "Personal Workspace",
    "teamWorkspace": "Team Workspace",
    "soloUseOnly": "Solo use only",
    "needTeamWorkspace": "Need team workspace?",
    "inviteUpTo": "Invite up to",
    "title": "Subscription",
    "titleUnsubscribed": "Subscribe to Comfy Cloud",
    "comfyCloud": "Comfy Cloud",
    "comfyCloudLogo": "Comfy Cloud Logo",
    "beta": "BETA",
    "perMonth": "/ month",
    "member": "member",
    "usdPerMonth": "USD / mo",
    "usdPerMonthPerMember": "USD / mo / member",
    "renewsDate": "Renews {date}",
    "expiresDate": "Expires {date}",
    "manageSubscription": "Manage subscription",
    "managePayment": "Manage Payment",
    "cancelSubscription": "Cancel Subscription",
    "canceled": "Canceled",
    "resubscribe": "Resubscribe",
    "resubscribeTo": "Resubscribe to {plan}",
    "resubscribeSuccess": "Subscription reactivated successfully",
    "canceledCard": {
      "title": "Your subscription has been canceled",
      "description": "You won't be charged again. Your features remain active until {date}."
    },
    "cancelSuccess": "Subscription cancelled successfully",
    "cancelDialog": {
      "title": "Cancel subscription",
      "description": "Your access continues until {date}. You won't be charged again, and your workspace and credits will be preserved. You can resubscribe anytime.",
      "endOfBillingPeriod": "end of billing period",
      "keepSubscription": "Keep subscription",
      "confirmCancel": "Cancel subscription",
      "failed": "Failed to cancel subscription"
    },
    "partnerNodesBalance": "\"Partner Nodes\" Credit Balance",
    "partnerNodesDescription": "For running commercial/proprietary models",
    "totalCredits": "Total credits",
    "viewUsageHistory": "View usage history",
    "addApiCredits": "Add API credits",
    "addCredits": "Add credits",
    "monthlyCreditsRollover": "These credits will rollover to the next month",
    "monthlyBonusDescription": "Monthly credit bonus",
    "prepaidDescription": "Pre-paid credits",
    "prepaidCreditsInfo": "Pre-paid credits expire after 1 year from purchase date.",
    "creditsRemainingThisMonth": "Included (Refills {date})",
    "creditsRemainingThisYear": "Included (Refills {date})",
    "creditsYouveAdded": "Additional",
    "monthlyCreditsInfo": "These credits refresh monthly and don't roll over",
    "viewMoreDetailsPlans": "View more details about plans & pricing",
    "nextBillingCycle": "next billing cycle",
    "yourPlanIncludes": "Your plan includes:",
    "viewMoreDetails": "View more details",
    "learnMore": "Learn more",
    "billedMonthly": "Billed monthly",
    "billedYearly": "{total} Billed yearly",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "tierNameYearly": "{name} Yearly",
    "messageSupport": "Message support",
    "invoiceHistory": "Invoice history",
    "refreshCredits": "Refresh credits",
    "benefits": {
      "benefit1": "Monthly credits for Partner Nodes — top up when needed",
      "benefit1FreeTier": "More monthly credits, top up anytime",
      "benefit2": "Up to 1 hour runtime per job on Pro",
      "benefit3": "Bring your own models (Creator & Pro)"
    },
    "yearlyDiscount": "20% DISCOUNT",
    "tiers": {
      "free": {
        "name": "Free"
      },
      "founder": {
        "name": "Founder's Edition"
      },
      "standard": {
        "name": "Standard"
      },
      "creator": {
        "name": "Creator"
      },
      "pro": {
        "name": "Pro"
      }
    },
    "required": {
      "title": "Subscribe to",
      "waitingForSubscription": "Complete your subscription in the new tab. We'll automatically detect when you're done!",
      "subscribe": "Subscribe",
      "pollingSuccess": "Subscription activated successfully!",
      "pollingFailed": "Subscription activation failed",
      "pollingTimeout": "Timed out waiting for subscription. Please refresh and try again."
    },
    "subscribeToRun": "Subscribe",
    "subscribeToRunFull": "Subscribe to Run",
    "subscribeForMore": "Upgrade",
    "upgradeToAddCredits": "Upgrade to add credits",
    "subscribeNow": "Subscribe Now",
    "subscribeToComfyCloud": "Subscribe to Comfy Cloud",
    "workspaceNotSubscribed": "This workspace is not on a subscription",
    "subscriptionRequiredMessage": "A subscription is required for members to run workflows on Cloud and invite members",
    "contactOwnerToSubscribe": "Contact the workspace owner to subscribe",
    "description": "Choose the best plan for you",
    "descriptionWorkspace": "Choose the best plan for your workspace",
    "haveQuestions": "Have questions or wondering about enterprise?",
    "contactUs": "Contact us",
    "viewEnterprise": "View enterprise",
    "freeTier": {
      "title": "You're on the Free plan",
      "description": "Your free plan includes {credits} credits each month to try Comfy Cloud.",
      "descriptionGeneric": "Your free plan includes a monthly credit allowance to try Comfy Cloud.",
      "nextRefresh": "Your credits refresh on {date}.",
      "subscribeCta": "Subscribe for more",
      "outOfCredits": {
        "title": "You're out of free credits",
        "subtitle": "Subscribe to unlock top-ups and more"
      },
      "topUpBlocked": {
        "title": "Unlock top-ups and more"
      },
      "upgradeCta": "View plans"
    },
    "partnerNodesCredits": "Partner nodes pricing",
    "plansAndPricing": "Plans & pricing",
    "managePlan": "Manage plan",
    "upgrade": "UPGRADE",
    "mostPopular": "Most popular",
    "currentPlan": "Current Plan",
    "subscribeTo": "Subscribe to {plan}",
    "monthlyCreditsLabel": "Monthly credits",
    "monthlyCreditsPerMemberLabel": "Monthly credits / member",
    "maxMembersLabel": "Max. members",
    "yearlyCreditsLabel": "Total yearly credits",
    "membersLabel": "Up to {count} members",
    "nextMonthInvoice": "Next month invoice",
    "memberCount": "{count} member | {count} members",
    "maxDurationLabel": "Max run duration",
    "gpuLabel": "RTX 6000 Pro (96GB VRAM)",
    "addCreditsLabel": "Add more credits whenever",
    "customLoRAsLabel": "Import your own LoRAs",
    "videoEstimateLabel": "Approx. amount of 5s videos generated with Wan 2.2 Image-to-Video template",
    "videoEstimateHelp": "More details on this template",
    "videoEstimateExplanation": "These estimates are based on the Wan 2.2 Image-to-Video template using default settings (5 sec, 16fps, 640x640, 4-step sampling).",
    "videoEstimateTryTemplate": "Try this template",
    "videoTemplateBasedCredits": "Videos generated with Wan 2.2 Image to Video",
    "upgradePlan": "Upgrade Plan",
    "upgradeTo": "Upgrade to {plan}",
    "changeTo": "Change to {plan}",
    "maxDuration": {
      "free": "30 min",
      "standard": "30 min",
      "creator": "30 min",
      "pro": "1 hr",
      "founder": "30 min"
    },
    "billingComingSoon": {
      "title": "Coming Soon",
      "message": "Team billing is coming soon. You'll be able to subscribe to a plan for your workspace with per-seat pricing. Stay tuned for updates."
    },
    "preview": {
      "confirmPayment": "Confirm your payment",
      "confirmPlanChange": "Confirm your plan change",
      "startingToday": "Starting today",
      "starting": "Starting {date}",
      "ends": "Ends {date}",
      "eachMonthCreditsRefill": "Each month credits refill to",
      "perMember": "/ member",
      "showMoreFeatures": "Show more features",
      "hideFeatures": "Hide features",
      "proratedRefund": "Prorated refund for {plan}",
      "proratedCharge": "Prorated charge for {plan}",
      "totalDueToday": "Total due today",
      "nextPaymentDue": "Next payment due {date}. Cancel anytime.",
      "termsAgreement": "By continuing, you agree to Comfy Org's {terms} and {privacy}.",
      "terms": "Terms",
      "privacyPolicy": "Privacy Policy",
      "addCreditCard": "Add credit card",
      "confirm": "Confirm",
      "backToAllPlans": "Back to all plans"
    }
  },
  "userSettings": {
    "title": "My Account Settings",
    "accountSettings": "Account settings",
    "workspaceSettings": "Workspace settings",
    "name": "Name",
    "email": "Email",
    "provider": "Sign-in Provider",
    "notSet": "Not set",
    "updatePassword": "Update Password"
  },
  "workspacePanel": {
    "invite": "Invite",
    "inviteMember": "Invite member",
    "inviteLimitReached": "You've reached the maximum of 50 members",
    "tabs": {
      "dashboard": "Dashboard",
      "planCredits": "Plan & Credits",
      "membersCount": "Members ({count})"
    },
    "dashboard": {
      "placeholder": "Dashboard workspace settings"
    },
    "members": {
      "membersCount": "{count}/{maxSeats} Members",
      "pendingInvitesCount": "{count} pending invite | {count} pending invites",
      "tabs": {
        "active": "Active",
        "pendingCount": "Pending ({count})"
      },
      "columns": {
        "inviteDate": "Invite date",
        "expiryDate": "Expiry date",
        "joinDate": "Join date"
      },
      "actions": {
        "copyLink": "Copy invite link",
        "revokeInvite": "Revoke invite",
        "removeMember": "Remove member"
      },
      "upsellBannerSubscribe": "Subscribe to the Creator plan or above to invite team members to this workspace.",
      "upsellBannerUpgrade": "Upgrade to the Creator plan or above to invite additional team members.",
      "viewPlans": "View plans",
      "noInvites": "No pending invites",
      "noMembers": "No members",
      "personalWorkspaceMessage": "You can't invite other members to your personal workspace right now. To add members to a workspace,",
      "createNewWorkspace": "create a new one."
    },
    "menu": {
      "editWorkspace": "Edit workspace details",
      "leaveWorkspace": "Leave Workspace",
      "deleteWorkspace": "Delete Workspace",
      "deleteWorkspaceDisabledTooltip": "Cancel your workspace's active subscription first"
    },
    "editWorkspaceDialog": {
      "title": "Edit workspace details",
      "nameLabel": "Workspace name",
      "save": "Save"
    },
    "leaveDialog": {
      "title": "Leave this workspace?",
      "message": "You won't be able to join again unless you contact the workspace owner.",
      "leave": "Leave"
    },
    "deleteDialog": {
      "title": "Delete this workspace?",
      "message": "Any unused credits or unsaved assets will be lost. This action cannot be undone.",
      "messageWithName": "Delete \"{name}\"? Any unused credits or unsaved assets will be lost. This action cannot be undone."
    },
    "removeMemberDialog": {
      "title": "Remove this member?",
      "message": "This member will be removed from your workspace. Credits they've used will not be refunded.",
      "remove": "Remove member",
      "success": "Member removed",
      "error": "Failed to remove member"
    },
    "revokeInviteDialog": {
      "title": "Uninvite this person?",
      "message": "This member won't be able to join your workspace anymore. Their invite link will be invalidated.",
      "revoke": "Uninvite"
    },
    "inviteUpsellDialog": {
      "titleNotSubscribed": "A subscription is required to invite members",
      "titleSingleSeat": "Your current plan supports a single seat",
      "messageNotSubscribed": "To add team members to this workspace, you need a Creator plan or above. The Standard plan supports only a single seat (the owner).",
      "messageSingleSeat": "The Standard plan includes one seat for the workspace owner. To invite additional members, upgrade to the Creator plan or above to unlock multiple seats.",
      "viewPlans": "View Plans",
      "upgradeToCreator": "Upgrade to Creator"
    },
    "inviteMemberDialog": {
      "title": "Invite a person to this workspace",
      "message": "Create a shareable invite link to send to someone",
      "placeholder": "Enter the person's email",
      "createLink": "Create link",
      "linkStep": {
        "title": "Send this link to the person",
        "message": "Make sure their account uses this email.",
        "copyLink": "Copy Link",
        "done": "Done"
      },
      "linkCopied": "Copied",
      "linkCopyFailed": "Failed to copy link"
    },
    "createWorkspaceDialog": {
      "title": "Create a new workspace",
      "message": "Workspaces create a new credit pool that can be shared among members. You'll become the owner after creating this.",
      "nameLabel": "Workspace name*",
      "namePlaceholder": "Enter workspace name",
      "create": "Create"
    },
    "toast": {
      "workspaceCreated": {
        "title": "Workspace created",
        "message": "Subscribe to a plan, invite teammates, and start collaborating.",
        "subscribe": "Subscribe"
      },
      "workspaceUpdated": {
        "title": "Workspace updated",
        "message": "Workspace details have been saved."
      },
      "workspaceDeleted": {
        "title": "Workspace deleted",
        "message": "The workspace has been permanently deleted."
      },
      "workspaceLeft": {
        "title": "Left workspace",
        "message": "You have left the workspace."
      },
      "failedToUpdateWorkspace": "Failed to update workspace",
      "failedToCreateWorkspace": "Failed to create workspace",
      "failedToDeleteWorkspace": "Failed to delete workspace",
      "failedToLeaveWorkspace": "Failed to leave workspace",
      "failedToFetchWorkspaces": "Failed to load workspaces"
    }
  },
  "teamWorkspacesDialog": {
    "title": "Team Workspaces",
    "subtitle": "Switch to an existing one or create a new workspace",
    "subtitleNoWorkspaces": "Create a new team workspace to share credits",
    "confirmCallbackFailed": "Workspace created but setup incomplete",
    "yourTeamWorkspaces": "Your team workspaces",
    "switch": "Switch",
    "newWorkspace": "New workspace",
    "namePlaceholder": "e.g. Marketing Team",
    "createWorkspace": "Create workspace",
    "nameValidationError": "Name must be 1–50 characters using letters, numbers, spaces, or common punctuation."
  },
  "workspaceSwitcher": {
    "switchWorkspace": "Switch workspace",
    "subscribe": "Subscribe",
    "personal": "Personal",
    "roleOwner": "Owner",
    "roleMember": "Member",
    "createWorkspace": "Create new workspace",
    "maxWorkspacesReached": "You can only own 10 workspaces. Delete one to create a new one.",
    "failedToSwitch": "Failed to switch workspace"
  },
  "selectionToolbox": {
    "executeButton": {
      "tooltip": "Execute to selected output nodes (Highlighted with orange border)",
      "disabledTooltip": "No output nodes selected"
    },
    "Set Group Nodes to Never": "Set Group Nodes to Never",
    "Bypass Group Nodes": "Bypass Group Nodes",
    "Set Group Nodes to Always": "Set Group Nodes to Always"
  },
  "widgets": {
    "boolean": {
      "true": "true",
      "false": "false"
    },
    "node2only": "Node 2.0 only",
    "selectModel": "Select model",
    "uploadSelect": {
      "placeholder": "Select...",
      "placeholderImage": "Select image...",
      "placeholderAudio": "Select audio...",
      "placeholderVideo": "Select video...",
      "placeholderMesh": "Select mesh...",
      "placeholderModel": "Select model...",
      "placeholderUnknown": "Select media...",
      "maxSelectionReached": "Maximum selection limit reached"
    },
    "valueControl": {
      "header": {
        "prefix": "Automatically update the value",
        "after": "AFTER",
        "before": "BEFORE",
        "postfix": "running the workflow:"
      },
      "linkToGlobal": "Link to",
      "linkToGlobalSeed": "Global Value",
      "linkToGlobalDesc": "Unique value linked to the Global Value's control setting",
      "randomize": "Randomize Value",
      "randomizeDesc": "Shuffles the value randomly after each generation",
      "increment": "Increment Value",
      "incrementDesc": "Adds 1 to value or selects the next option",
      "decrement": "Decrement Value",
      "decrementDesc": "Subtracts 1 from value or selects the previous option",
      "fixed": "Fixed Value",
      "fixedDesc": "Leaves value unchanged",
      "editSettings": "Edit control settings"
    }
  },
  "widgetFileUpload": {
    "dropPrompt": "Drop your file or",
    "browseFiles": "Browse Files"
  },
  "nodeHelpPage": {
    "inputs": "Inputs",
    "outputs": "Outputs",
    "type": "Type",
    "moreHelp": "For more help, visit the",
    "documentationPage": "documentation page",
    "loadError": "Failed to load help: {error}"
  },
  "whatsNewPopup": {
    "learnMore": "Learn more",
    "later": "Later",
    "noReleaseNotes": "No release notes available."
  },
  "breadcrumbsMenu": {
    "blueprint": "Blueprint",
    "duplicate": "Duplicate",
    "enterAppMode": "Enter app mode",
    "exitAppMode": "Exit app mode",
    "enterBuilderMode": "Build app",
    "editBuilderMode": "Edit app",
    "workflowActions": "Workflow actions",
    "clearWorkflow": "Clear Workflow",
    "deleteWorkflow": "Delete Workflow",
    "deleteBlueprint": "Delete Blueprint",
    "enterNewName": "Enter new name",
    "missingNodesWarning": "Workflow contains unsupported nodes (highlighted red).",
    "graph": "Graph",
    "app": "App",
    "enterNodeGraph": "Enter node graph",
    "share": "Share"
  },
  "shortcuts": {
    "shortcuts": "Shortcuts",
    "essentials": "Essential",
    "viewControls": "View Controls",
    "manageShortcuts": "Manage Shortcuts",
    "noKeybinding": "No keybinding",
    "keyboardShortcuts": "Keyboard Shortcuts",
    "subcategories": {
      "workflow": "Workflow",
      "node": "Node",
      "queue": "Queue",
      "view": "View",
      "panelControls": "Panel Controls"
    }
  },
  "minimap": {
    "nodeColors": "Node Colors",
    "showLinks": "Show Links",
    "showGroups": "Show Frames/Groups",
    "renderBypassState": "Render Bypass State",
    "renderErrorState": "Render Error State"
  },
  "nightlySurvey": {
    "title": "Help Us Improve",
    "description": "You've been using this feature. Would you take a moment to share your feedback?",
    "accept": "Sure, I'll help!",
    "notNow": "Not Now",
    "dontAskAgain": "Don't Ask Again",
    "loadError": "Failed to load survey. Please try again later."
  },
  "errorPanelSurvey": {
    "ctaText": "How's the new error panel?",
    "ctaButton": "Give feedback"
  },
  "cloudOnboarding": {
    "skipToCloudApp": "Skip to the cloud app",
    "survey": {
      "title": "Cloud Survey",
      "placeholder": "Survey questions placeholder",
      "intro": "Help us tailor your ComfyUI experience.",
      "errors": {
        "chooseAnOption": "Please choose an option.",
        "selectAtLeastOne": "Please select at least one option.",
        "describeAnswer": "Please describe your answer."
      },
      "steps": {
        "usage": "How do you plan to use ComfyUI?",
        "familiarity": "How familiar are you with ComfyUI?",
        "intent": "What do you want to create with ComfyUI?",
        "source": "Where did you hear about ComfyUI?"
      },
      "options": {
        "usage": {
          "personal": "Personal use",
          "work": "Work",
          "education": "Education (student or educator)"
        },
        "familiarity": {
          "new": "New — never used it",
          "starting": "Beginner — following tutorials",
          "basics": "Intermediate — comfortable with basics",
          "advanced": "Advanced — build and edit workflows",
          "expert": "Expert — I help others"
        },
        "intent": {
          "workflows": "Custom workflows or pipelines",
          "custom_nodes": "Custom nodes",
          "videos": "Videos",
          "images": "Images",
          "3d_game": "3D assets / game assets",
          "audio": "Audio / music",
          "apps": "Simplified Apps from workflows",
          "api": "API endpoints to run workflows",
          "not_sure": "Not sure"
        },
        "source": {
          "youtube": "YouTube",
          "reddit": "Reddit",
          "twitter": "Twitter / X",
          "instagram": "Instagram",
          "linkedin": "LinkedIn",
          "friend": "Friend or colleague",
          "search": "Google / search",
          "newsletter": "Newsletter or blog",
          "conference": "Conference or event",
          "discord": "Discord / community",
          "github": "GitHub",
          "other": "Other"
        }
      }
    },
    "forgotPassword": {
      "title": "Forgot Password",
      "instructions": "Enter your email address and we'll send you a link to reset your password.",
      "emailLabel": "Email",
      "emailPlaceholder": "Enter your email",
      "sendResetLink": "Send reset link",
      "backToLogin": "Back to login",
      "didntReceiveEmail": "Didn't receive an email? Contact us at",
      "passwordResetSent": "Password reset email sent",
      "passwordResetError": "Failed to send password reset email. Please try again.",
      "emailRequired": "Email is required"
    },
    "privateBeta": {
      "title": "Cloud is currently in private beta",
      "desc": "Sign in to join the waitlist. We’ll notify you when it’s your turn. Already been notified? Sign in start using Cloud."
    },
    "start": {
      "title": "start creating in seconds",
      "desc": "Zero setup required. Works on any device.",
      "explain": "Generate multiple outputs at once. Share workflows with ease.",
      "learnAboutButton": "Learn about Cloud",
      "wantToRun": "Want to run ComfyUI locally instead?",
      "download": "Download ComfyUI"
    },
    "checkingStatus": "Checking your account status...",
    "retrying": "Retrying...",
    "retry": "Try Again",
    "authTimeout": {
      "title": "Connection Taking Too Long",
      "message": "We're having trouble connecting to ComfyUI Cloud. This could be due to a slow connection or temporary service issue.",
      "restart": "Sign Out & Try Again",
      "troubleshooting": "Common causes:",
      "causes": [
        "Corporate firewall or proxy blocking authentication services",
        "VPN or network restrictions",
        "Browser extensions interfering with requests",
        "Regional network limitations",
        "Try a different browser or network"
      ],
      "technicalDetails": "Technical Details",
      "helpText": "Need help? Contact",
      "supportLink": "support"
    }
  },
  "cloudFooter_needHelp": "Need Help?",
  "cloudStart_title": "start creating in seconds",
  "cloudStart_desc": "Zero setup required. Works on any device.",
  "cloudStart_explain": "Generate multiple outputs at once. Share workflows with ease.",
  "cloudStart_learnAboutButton": "Learn about Cloud",
  "cloudStart_wantToRun": "Want to run ComfyUI locally instead?",
  "cloudStart_download": "Download ComfyUI",
  "cloudWaitlist_questionsText": "Questions? Contact us",
  "cloudWaitlist_contactLink": "here",
  "cloudSorryContactSupport_title": "Sorry, contact support",
  "cloudPrivateBeta_title": "Cloud is currently in private beta",
  "cloudPrivateBeta_desc": "Sign in to join the waitlist. We'll notify you when it's your turn. Already been notified? Sign in start using Cloud.",
  "cloudForgotPassword_title": "Forgot Password",
  "cloudForgotPassword_instructions": "Enter your email address and we'll send you a link to reset your password.",
  "cloudForgotPassword_emailLabel": "Email",
  "cloudForgotPassword_emailPlaceholder": "Enter your email",
  "cloudForgotPassword_sendResetLink": "Send reset link",
  "cloudForgotPassword_backToLogin": "Back to login",
  "cloudForgotPassword_didntReceiveEmail": "Didn't receive an email?",
  "cloudForgotPassword_emailRequired": "Email is required",
  "cloudForgotPassword_passwordResetSent": "Password reset sent",
  "cloudForgotPassword_passwordResetError": "Failed to send password reset email",
  "cloudSurvey_steps_usage": "How do you plan to use ComfyUI?",
  "cloudSurvey_steps_familiarity": "How familiar are you with ComfyUI?",
  "cloudSurvey_steps_intent": "What do you want to create with ComfyUI?",
  "cloudSurvey_steps_source": "Where did you hear about ComfyUI?",
  "assetBrowser": {
    "allCategory": "All {category}",
    "allModels": "All Models",
    "byType": "By type",
    "emptyImported": {
      "canImport": "No imported models yet. Click \"Import\" to add your own.",
      "restricted": "Personal models are only available at Creator tier and above."
    },
    "noResultsCanImport": "Try adjusting your search or filters.\nYou can also add models using the \"Import\" button above.",
    "imported": "Imported",
    "assetCollection": "Asset collection",
    "assets": "Assets",
    "baseModel": "Base model",
    "baseModels": "Base models",
    "browseAssets": "Browse Assets",
    "checkpoints": "Checkpoints",
    "civitaiLinkExample": "{example} {link}",
    "civitaiLinkExampleStrong": "Example:",
    "civitaiLinkExampleUrl": "https://civitai.com/models/10706/luisap-z-image-and-qwen-pixel-art-refiner?modelVersionId=2225295",
    "civitaiLinkLabel": "Civitai model {download} link",
    "civitaiLinkLabelDownload": "download",
    "civitaiLinkPlaceholder": "Paste link here",
    "confirmModelDetails": "Confirm Model Details",
    "connectionError": "Please check your connection and try again",
    "errorAccessForbidden": "Access to this resource is forbidden.",
    "errorConnectionRefused": "Unable to connect to the source. Please try again later.",
    "errorDownloadCancelled": "Download was cancelled.",
    "errorFileTooLarge": "File exceeds the maximum allowed size limit",
    "errorFormatNotAllowed": "Only SafeTensor format is allowed",
    "errorHttpError": "An error occurred while fetching metadata.",
    "errorInternalError": "An unexpected error occurred. Please try again.",
    "errorInvalidHost": "The source URL hostname could not be resolved.",
    "errorInvalidUrl": "Please provide a URL.",
    "errorInvalidUrlFormat": "The URL format is invalid. Please check and try again.",
    "errorMetadataFetchFailed": "Failed to fetch file information from the source.",
    "errorModelTypeNotSupported": "This model type is not supported",
    "errorNetworkError": "A network error occurred. Please check your connection and try again.",
    "errorNetworkTimeout": "Request timed out. Please try again.",
    "errorRateLimited": "Too many requests. Please try again in a few minutes.",
    "errorRequestCancelled": "Request was cancelled.",
    "errorResourceNotFound": "The file was not found. Please check the URL and try again.",
    "errorServiceUnavailable": "Service temporarily unavailable. Please try again later.",
    "errorSourceServerError": "The source server is experiencing issues. Please try again later.",
    "errorUnauthorized": "Please sign in to continue.",
    "errorUnauthorizedSource": "This resource requires authentication. Please add your API token in settings.",
    "errorUnknown": "An unexpected error occurred",
    "errorUnsafePickleScan": "CivitAI detected potentially unsafe code in this file",
    "errorUnsafeVirusScan": "CivitAI detected malware or suspicious content in this file",
    "errorUnsupportedSource": "This URL is not supported. Only Hugging Face and Civitai URLs are allowed.",
    "errorUploadFailed": "Failed to import asset. Please try again.",
    "errorUserTokenAccessDenied": "Your API token does not have access to this resource. Please check your token permissions.",
    "errorUserTokenInvalid": "Your stored API token is invalid or expired. Please update your token in settings.",
    "invalidAsset": "Invalid Asset",
    "invalidAssetDetail": "The selected asset could not be validated. Please try again.",
    "invalidFilename": "Invalid Filename",
    "invalidFilenameDetail": "The asset filename could not be determined. Please try again.",
    "failedToCreateNode": "Failed to create node. Please try again or check console for details.",
    "fileFormats": "File formats",
    "fileName": "File Name",
    "fileSize": "File Size",
    "filterBy": "Filter by",
    "findInLibrary": "Find it in the {type} section of the models library.",
    "finish": "Finish",
    "importAnother": "Import Another",
    "genericLinkPlaceholder": "Paste link here",
    "gridView": "Grid view",
    "jobId": "Job ID",
    "listView": "List view",
    "loadingModels": "Loading {type}...",
    "maxFileSize": "Max file size: {size}",
    "maxFileSizeValue": "1 GB",
    "modelAssociatedWithLink": "The model associated with the link you provided:",
    "modelName": "Model Name",
    "modelNamePlaceholder": "Enter a name for this model",
    "modelTypeSelectorLabel": "What type of model is this?",
    "modelTypeSelectorPlaceholder": "Select model type",
    "modelUploaded": "Model successfully imported.",
    "noAssetsFound": "No assets found",
    "noModelsInFolder": "No {type} available in this folder",
    "notSureLeaveAsIs": "Not sure? Just leave this as is",
    "noValidSourceDetected": "No valid import source detected",
    "onlyCivitaiUrlsSupported": "Only Civitai URLs are supported",
    "ownership": "Ownership",
    "ownershipAll": "All",
    "ownershipMyModels": "My models",
    "ownershipPublicModels": "Public models",
    "processingModel": "Download started",
    "processingModelDescription": "You can close this dialog. The download will continue in the background.",
    "providerCivitai": "Civitai",
    "providerHuggingFace": "Hugging Face",
    "selectFrameworks": "Select Frameworks",
    "selectModelType": "Select model type",
    "selectProjects": "Select Projects",
    "sortAZ": "A-Z",
    "sortDefault": "Default",
    "sortBy": "Sort by",
    "sortingType": "Sorting Type",
    "sortPopular": "Popular",
    "sortRecent": "Recent",
    "sortUnsorted": "Unsorted",
    "sortZA": "Z-A",
    "tags": "Tags",
    "tagsHelp": "Separate tags with commas",
    "tagsPlaceholder": "e.g., models, checkpoint",
    "tryAdjustingFilters": "Try adjusting your search or filters",
    "unknown": "Unknown",
    "unsupportedUrlSource": "This URL is not supported. Use a direct model link from {sources}. See the how-to videos below for help.",
    "upgradeFeatureDescription": "This feature is only available with Creator or Pro plans.",
    "upgradeToUnlockFeature": "Upgrade to unlock this feature",
    "upload": "Import",
    "uploadFailed": "Import failed",
    "apiKeyHint": "Importing private or gated models? {link}.",
    "apiKeyHintLink": "Add your API keys in Settings",
    "uploadingModel": "Importing model...",
    "uploadModel": "Import",
    "uploadModelDescription1": "Paste a Civitai model download link to add it to your library.",
    "uploadModelDescription1Generic": "Paste a model download link to add it to your library.",
    "uploadModelDescription2": "Only links from {link} are supported at the moment",
    "uploadModelDescription2Generic": "Only URLs from the following providers are supported:",
    "uploadModelDescription2Link": "https://civitai.com/models",
    "uploadModelDescription3": "Max file size: {size}",
    "uploadModelFailedToRetrieveMetadata": "Failed to retrieve metadata. Please check the link and try again.",
    "uploadModelFromCivitai": "Import a model from Civitai",
    "uploadModelGeneric": "Import a model",
    "uploadModelHelpFooterText": "Need help finding the URLs? Click on a provider below to see a how-to video.",
    "uploadModelHelpVideo": "Upload Model Help Video",
    "uploadModelHowDoIFindThis": "How do I find this?",
    "uploadSuccess": "Model imported successfully!",
    "ariaLabel": {
      "assetCard": "{name} - {type} asset",
      "loadingAsset": "Loading asset"
    },
    "modelInfo": {
      "title": "Model Info",
      "selectModelPrompt": "Select a model to see its information",
      "basicInfo": "Basic Info",
      "displayName": "Display Name",
      "editDisplayName": "Edit display name",
      "fileName": "File Name",
      "source": "Source",
      "viewOnSource": "View on {source}",
      "modelTagging": "Model Tagging",
      "modelType": "Model Type",
      "selectModelType": "Select model type...",
      "compatibleBaseModels": "Compatible Base Models",
      "addBaseModel": "Add base model...",
      "baseModelUnknown": "Base model unknown",
      "additionalTags": "Additional Tags",
      "addTag": "Add tag...",
      "noAdditionalTags": "No additional tags",
      "modelDescription": "Model Description",
      "triggerPhrases": "Trigger Phrases",
      "description": "Description",
      "descriptionNotSet": "No description set",
      "descriptionPlaceholder": "Add a description for this model..."
    },
    "media": {
      "threeDModelPlaceholder": "3D Model",
      "audioPlaceholder": "Audio"
    },
    "deletion": {
      "header": "Delete this model?",
      "body": "This model will be permanently removed from your library.",
      "inProgress": "Deleting {assetName}...",
      "complete": "{assetName} has been deleted.",
      "failed": "{assetName} could not be deleted."
    },
    "download": {
      "complete": "Download complete",
      "failed": "Download failed",
      "inProgress": "Downloading {assetName}..."
    },
    "rename": {
      "failed": "Could not rename asset."
    }
  },
  "mediaAsset": {
    "deleteAssetTitle": "Delete this asset?",
    "deleteAssetDescription": "This asset will be permanently removed.",
    "deleteSelectedTitle": "Delete selected assets?",
    "deleteSelectedDescription": "{count} asset(s) will be permanently removed.",
    "assetDeletedSuccessfully": "Asset deleted successfully",
    "deletingImportedFilesCloudOnly": "Deleting imported files is only supported in cloud version",
    "failedToDeleteAsset": "Failed to delete asset",
    "actions": {
      "inspect": "Inspect asset",
      "more": "More options",
      "zoom": "Zoom in",
      "moreOptions": "More options",
      "seeMoreOutputs": "See more outputs",
      "insertAsNodeInWorkflow": "Insert as node in workflow",
      "download": "Download",
      "openWorkflow": "Open as workflow in new tab",
      "exportWorkflow": "Export workflow",
      "copyJobId": "Copy job ID",
      "delete": "Delete"
    },
    "jobIdToast": {
      "jobIdCopied": "Job ID copied to clipboard",
      "jobIdCopyFailed": "Failed to copy Job ID",
      "copied": "Copied",
      "error": "Error"
    },
    "selection": {
      "selectedCount": "Assets Selected: {count}",
      "multipleSelectedAssets": "Multiple assets selected",
      "deselectAll": "Deselect all",
      "downloadSelected": "Download",
      "downloadSelectedAll": "Download all",
      "deleteSelected": "Delete",
      "deleteSelectedAll": "Delete all",
      "insertAllAssetsAsNodes": "Insert all assets as nodes",
      "openWorkflowAll": "Open all workflows",
      "exportWorkflowAll": "Export all workflows",
      "downloadStarted": "Downloading {count} file... | Downloading {count} files...",
      "downloadsStarted": "Started downloading {count} file | Started downloading {count} files",
      "exportStarted": "Preparing ZIP export for {count} file | Preparing ZIP export for {count} files",
      "assetsDeletedSuccessfully": "{count} asset deleted successfully | {count} assets deleted successfully",
      "failedToDeleteAssets": "Failed to delete selected assets",
      "partialDeleteSuccess": "{succeeded} deleted successfully, {failed} failed",
      "nodesAddedToWorkflow": "{count} node(s) added to workflow",
      "failedToAddNodes": "Failed to add nodes to workflow",
      "partialAddNodesSuccess": "{succeeded} added successfully, {failed} failed",
      "workflowsOpened": "{count} workflow(s) opened in new tabs",
      "noWorkflowsFound": "No workflow data found in selected assets",
      "partialWorkflowsOpened": "{succeeded} workflow(s) opened, {failed} failed",
      "workflowsExported": "{count} workflow(s) exported successfully",
      "noWorkflowsToExport": "No workflow data found to export",
      "partialWorkflowsExported": "{succeeded} exported successfully, {failed} failed"
    },
    "noJobIdFound": "No job ID found for this asset",
    "unsupportedFileType": "Unsupported file type for loader node",
    "nodeTypeNotFound": "Node type {nodeType} not found",
    "failedToCreateNode": "Failed to create node",
    "nodeAddedToWorkflow": "{nodeType} node added to workflow",
    "noWorkflowDataFound": "No workflow data found in this asset",
    "workflowOpenedInNewTab": "Workflow opened in new tab",
    "failedToExportWorkflow": "Failed to export workflow",
    "workflowExportedSuccessfully": "Workflow exported successfully"
  },
  "actionbar": {
    "dockToTop": "Dock to top",
    "feedback": "Feedback",
    "feedbackTooltip": "Feedback",
    "share": "Share",
    "shareTooltip": "Share workflow"
  },
  "shareNoOutputs": {
    "title": "App has no outputs",
    "message": "You're about to share an app without outputs. It can't be used until an output is connected.\n\nShare anyway?",
    "shareAnyway": "Share anyway"
  },
  "shareWorkflow": {
    "shareLinkTab": "Share",
    "publishToHubTab": "Publish",
    "loadingTitle": "Share workflow",
    "unsavedTitle": "Save workflow first",
    "unsavedDescription": "You must save your workflow before sharing. Save it now to continue.",
    "saveButton": "Save workflow",
    "saving": "Saving...",
    "workflowNameLabel": "Workflow name",
    "createLinkTitle": "Share workflow",
    "createLinkDescription": "When you create a link for your workflow, you will share these media items along with your workflow",
    "privateAssetsDescription": "Your workflow contains private models and/or media files",
    "createLinkButton": "Create a link",
    "creatingLink": "Creating a link...",
    "successTitle": "Workflow successfully published!",
    "successDescription": "Anyone with this link can view and use this workflow. If you make changes to this workflow, you can republish to update the shared version.",
    "hasChangesTitle": "Share workflow",
    "hasChangesDescription": "You have made changes since this workflow was last published.",
    "updateLinkButton": "Update link",
    "updatingLink": "Updating link...",
    "publishedOn": "Published on {date}",
    "copyLink": "Copy",
    "linkCopied": "Copied!",
    "shareUrlLabel": "Share URL",
    "loadFailed": "Failed to load shared workflow",
    "saveFailedTitle": "Save failed",
    "saveFailedDescription": "Failed to save workflow. Please try again.",
    "mediaLabel": "{count} Media File | {count} Media Files",
    "modelsLabel": "{count} Model | {count} Models",
    "checkingAssets": "Checking media visibility…",
    "acknowledgeCheckbox": "I understand these media items will be published and made public",
    "inLibrary": "In library",
    "comfyHubTitle": "Upload to ComfyHub",
    "comfyHubDescription": "ComfyHub is ComfyUI's official community hub.\nYour workflow will have a public page viewable by all.",
    "comfyHubButton": "Upload to ComfyHub"
  },
  "openSharedWorkflow": {
    "dialogTitle": "Open shared workflow",
    "author": "Author:",
    "copyDescription": "Opening the workflow will create a new copy in your workspace",
    "nonPublicAssetsWarningLine1": "This workflow comes with non-public assets.",
    "nonPublicAssetsWarningLine2": "These will be imported to your library when you open the workflow",
    "copyAssetsAndOpen": "Import assets & open workflow",
    "openWorkflow": "Open workflow",
    "openWithoutImporting": "Open without importing",
    "opening": "Opening shared workflow...",
    "importFailed": "Failed to import workflow assets",
    "loadError": "Could not load this shared workflow. Please try again later."
  },
  "comfyHubPublish": {
    "title": "Publish to ComfyHub",
    "unsavedDescription": "You must save your workflow before publishing to ComfyHub. Save it now to continue.",
    "stepDescribe": "Describe your workflow",
    "stepExamples": "Add output examples",
    "stepFinish": "Finish publishing",
    "workflowName": "Workflow name",
    "workflowNamePlaceholder": "Tip: enter a descriptive name that's easy to search",
    "workflowDescription": "Workflow description",
    "workflowDescriptionPlaceholder": "What makes your workflow exciting and special? Be specific so people know what to expect.",
    "tags": "Tags",
    "tagsDescription": "Select tags so people can find your workflow faster",
    "tagsPlaceholder": "Enter tags that match your workflow to help people find it e.g #nanobanana, #anime or #faceswap",
    "selectAThumbnail": "Select a thumbnail",
    "showMoreTags": "Show more...",
    "showLessTags": "Show less...",
    "suggestedTags": "Suggested tags",
    "thumbnailImage": "Image",
    "thumbnailVideo": "Video",
    "thumbnailImageComparison": "Image comparison",
    "uploadThumbnail": "Upload an image",
    "uploadVideo": "Upload a video",
    "uploadComparison": "Upload before and after",
    "thumbnailPreview": "Thumbnail preview",
    "uploadPromptClickToBrowse": "Click to browse or",
    "uploadPromptDropImage": "drop an image here",
    "uploadPromptDropVideo": "drop a video here",
    "uploadComparisonBeforePrompt": "Before",
    "uploadComparisonAfterPrompt": "After",
    "uploadThumbnailHint": "1:1 preferred, 1080p max",
    "back": "Back",
    "next": "Next",
    "publishButton": "Publish to ComfyHub",
    "examplesDescription": "Add up to {total} additional sample images",
    "uploadAnImage": "Click to browse or drag an image",
    "uploadExampleImage": "Upload example image",
    "removeExampleImage": "Remove example image",
    "exampleImage": "Example image {index}",
    "exampleImagePosition": "Example image {index} of {total}",
    "videoPreview": "Video thumbnail preview",
    "maxExamples": "You can select up to {max} examples",
    "shareAs": "Share as",
    "additionalInfo": "Additional information",
    "createProfileToPublish": "Create a profile to publish to ComfyHub",
    "createProfileCta": "Create a profile",
    "publishFailedTitle": "Publish failed",
    "publishFailedDescription": "Something went wrong while publishing your workflow. Please try again.",
    "publishSuccessTitle": "Published successfully",
    "publishSuccessDescription": "Your workflow is now live on ComfyHub."
  },
  "comfyHubProfile": {
    "checkingAccess": "Checking your publishing access...",
    "profileCreationNav": "Profile creation",
    "introTitle": "Publish to the ComfyHub",
    "introDescription": "Publish your workflows, build your portfolio and get discovered by millions of users",
    "introSubtitle": "To share your workflow on ComfyHub, let's first create your profile.",
    "createProfileButton": "Create my profile",
    "startPublishingButton": "Start publishing",
    "modalTitle": "Create your profile on ComfyHub",
    "createProfileTitle": "Create your Comfy Hub profile",
    "uploadCover": "+ Upload a cover",
    "uploadProfilePicture": "+ Upload a profile picture",
    "chooseProfilePicture": "Choose a profile picture",
    "nameLabel": "Your name",
    "namePlaceholder": "Enter your name here",
    "usernameLabel": "Your username (required)",
    "usernamePlaceholder": "@",
    "usernameError": "3–42 lowercase alphanumeric characters and hyphens, must start and end with a letter or number",
    "descriptionLabel": "Your description",
    "descriptionPlaceholder": "Tell the community about yourself...",
    "createProfile": "Create profile",
    "creatingProfile": "Creating profile...",
    "successTitle": "Looking good, {'@'}{username}!",
    "successProfileUrl": "Your profile page is live at",
    "successProfileLink": "comfy.com/p/{username}",
    "successDescription": "You can now upload your workflow to your creator page",
    "uploadWorkflowButton": "Upload my workflow"
  },
  "desktopDialogs": {
    "": {
      "title": "Invalid Dialog",
      "message": "Invalid dialog ID was provided.",
      "buttons": {
        "Close": "Close"
      }
    }
  },
  "vueNodesSlot": {
    "iterative": "(Iterative)"
  },
  "vueNodesBanner": {
    "title": "Introducing Nodes 2.0",
    "desc": "– More flexible workflows, powerful new widgets, built for extensibility",
    "tryItOut": "Try it out"
  },
  "appBuilder": {
    "vueNodeSwitch": {
      "title": "Switched over to Nodes 2.0",
      "content": "For the best experience, App builder uses Nodes 2.0. You can switch back after building the app from the main menu.",
      "dontShowAgain": "Don't show again",
      "dismiss": "Dismiss"
    }
  },
  "vueNodesMigration": {
    "message": "Prefer the legacy design?",
    "button": "Switch back"
  },
  "vueNodesMigrationMainMenu": {
    "message": "Switch back to Nodes 2.0 anytime from the main menu."
  },
  "linearMode": {
    "linearMode": "App Mode",
    "beta": "App mode in beta",
    "buildAnApp": "Build an app",
    "giveFeedback": "Give feedback",
    "graphMode": "Graph Mode",
    "dragAndDropImage": "Click to browse or drag an image",
    "mobileControls": "Edit & Run",
    "runCount": "Number of runs",
    "rerun": "Rerun",
    "reuseParameters": "Reuse Parameters",
    "downloadAll": "Download {count} assets from this run",
    "viewJob": "View Job",
    "enterNodeGraph": "Enter node graph",
    "emptyWorkflowExplanation": "Your workflow is empty. You need some nodes first to start building an app.",
    "backToWorkflow": "Back to workflow",
    "loadTemplate": "Load a template",
    "cancelThisRun": "Cancel this run",
    "deleteAllAssets": "Delete all assets from this run",
    "hasCreditCost": "Requires additional credits",
    "viewGraph": "View node graph",
    "mobileNoWorkflow": "This workflow hasn't been built for app mode. Try a different one.",
    "welcome": {
      "title": "App Mode",
      "message": "A simplified view that hides the node graph so you can focus on creating.",
      "controls": "Your outputs appear at the bottom, your controls are on the right. Everything else stays out of the way.",
      "sharing": "Share your workflow as a simple tool anyone can use. Export it from the tab menu and when others open it, they'll see App Mode. No node graph knowledge needed.",
      "getStarted": "Click {runButton} to get started.",
      "buildApp": "Build app",
      "noOutputs": "An app needs at least {count} to be usable.",
      "oneOutput": "1 output"
    },
    "appModeToolbar": {
      "appBuilder": "App builder",
      "apps": "Apps",
      "appsEmptyMessage": "Saved apps will show up here.",
      "appsEmptyMessageAction": "Click below to build your first app."
    },
    "arrange": {
      "noOutputs": "No outputs added yet",
      "switchToOutputs": "Switch to the 'Output' step and click on output nodes to add them here.",
      "connectAtLeastOne": "Connect {atLeastOne} output node so users can see results after running.",
      "atLeastOne": "at least one",
      "outputExamples": "Examples: 'Save Image' or 'Save Video'",
      "switchToOutputsButton": "Switch to Outputs",
      "outputs": "Outputs",
      "resultsLabel": "Results generated from the selected output node(s) will be shown here after running this app"
    },
    "builder": {
      "title": "App builder mode",
      "exit": "Exit builder",
      "exitConfirmTitle": "Exit app builder?",
      "exitConfirmMessage": "You have unsaved changes that will be lost\nExit without saving?",
      "promptAddInputs": "Click on node parameters to add them here as inputs",
      "noInputs": "No inputs added yet",
      "inputsDesc": "Users will interact and adjust these to generate their outputs.",
      "inputsExample": "Examples: “Load image”, “Text prompt”, “Steps”",
      "promptAddOutputs": "Click on output nodes to add them here. These will be the generated results.",
      "noOutputs": "No output nodes added yet",
      "outputsDesc": "Connect at least one output node so users can see results after running.",
      "outputsExample": "Examples: “Save Image” or “Save Video”",
      "unknownWidget": "Widget not visible",
      "inputPlaceholder": "Inputs will show up here",
      "outputPlaceholder": "Output nodes will show up here",
      "outputRequiredPlaceholder": "At least one node is required"
    },
    "error": {
      "header": "This app encountered an error",
      "log": "Error Logs",
      "mobileFixable": "Check {0} for errors",
      "requiresGraph": "Something went wrong during generation. This could be due to invalid hidden inputs, missing resources, or workflow configuration issues.",
      "promptVisitGraph": "View the node graph to see the full error.",
      "getHelp": "For help, view our {0}, {1}, or {2} with the copied error.",
      "goto": "Show errors in graph",
      "github": "submit a GitHub issue",
      "guide": "troubleshooting guide",
      "support": "contact our support",
      "promptShow": "Show error report"
    },
    "queue": {
      "clickToClear": "Click to clear queue",
      "clear": "Clear queue"
    }
  },
  "missingNodes": {
    "cloud": {
      "title": "These nodes aren't available on Comfy Cloud yet",
      "description": "This workflow uses custom nodes that aren't supported in the Cloud version yet.",
      "priorityMessage": "We've automatically flagged these nodes so we can prioritize adding them.",
      "replacementInstruction": "In the meantime, replace these nodes (highlighted red on the canvas) with supported ones if possible, or try a different workflow.",
      "learnMore": "Learn more",
      "gotIt": "Ok, got it"
    },
    "oss": {
      "title": "This workflow has missing nodes",
      "description": "This workflow uses custom nodes you haven't installed yet.",
      "replacementInstruction": "Install these nodes to run this workflow, or replace them with installed alternatives. Missing nodes are highlighted in red on the canvas."
    }
  },
  "nodeReplacement": {
    "quickFixAvailable": "Quick Fix Available",
    "installationRequired": "Installation Required",
    "compatibleAlternatives": "Compatible Alternatives",
    "replaceable": "Replaceable",
    "replaced": "Replaced",
    "notReplaceable": "Install Required",
    "selectAll": "Select All",
    "replaceSelected": "Replace Selected ({count})",
    "replacedNode": "Replaced node: {nodeType}",
    "replacedAllNodes": "Replaced {count} node type(s)",
    "replaceFailed": "Failed to replace nodes",
    "instructionMessage": "You must install these nodes or replace them with installed alternatives to run the workflow. Missing nodes are highlighted in {red} on the canvas. Some nodes cannot be swapped and must be installed via Node Manager.",
    "redHighlight": "red",
    "openNodeManager": "Open Node Manager",
    "skipForNow": "Skip for Now",
    "installMissingNodes": "Install Missing Nodes",
    "replaceWarning": "This will permanently modify the workflow. Save a copy first if unsure.",
    "swapNodesGuide": "The following nodes can be automatically replaced with compatible alternatives.",
    "willBeReplacedBy": "This node will be replaced by:",
    "replaceNode": "Replace Node",
    "replaceAll": "Replace All",
    "unknownNode": "Unknown",
    "replaceAllWarning": "Replaces all available nodes in this group.",
    "swapNodesTitle": "Swap Nodes"
  },
  "rightSidePanel": {
    "togglePanel": "Toggle properties panel",
    "editTitle": "Edit title",
    "editSubgraph": "Edit subgraph",
    "noSelection": "Select a node to see its properties and info.",
    "workflowOverview": "Workflow Overview",
    "title": "No item(s) selected | 1 item selected | {count} items selected",
    "parameters": "Parameters",
    "nodes": "Nodes",
    "info": "Info",
    "color": "Node color",
    "pinned": "Pinned",
    "bypass": "Bypass",
    "normal": "Normal",
    "mute": "Mute",
    "inputs": "INPUTS",
    "inputsNone": "NO INPUTS",
    "inputsNoneTooltip": "Node has no inputs",
    "advancedInputs": "ADVANCED INPUTS",
    "showAdvancedInputsButton": "Show advanced inputs",
    "showAdvancedShort": "Show advanced",
    "properties": "Properties",
    "nodeState": "Node state",
    "settings": "Settings",
    "addFavorite": "Favorite",
    "removeFavorite": "Unfavorite",
    "hideInput": "Hide input",
    "showInput": "Show input",
    "locateNode": "Locate node on canvas",
    "favorites": "FAVORITED INPUTS",
    "favoritesNone": "NO FAVORITED INPUTS",
    "favoritesNoneTooltip": "Star widgets to quickly access them without selecting nodes",
    "globalSettings": {
      "title": "Global Settings",
      "searchPlaceholder": "Search quick settings...",
      "nodes": "NODES",
      "canvas": "CANVAS",
      "connectionLinks": "CONNECTION LINKS",
      "showAdvanced": "Show advanced parameters",
      "showAdvancedTooltip": "This is an important setting that when set to TRUE, reveals all advanced parameters for nodes",
      "showInfoBadges": "Show info badges",
      "showToolbox": "Show toolbox on selection",
      "nodes2": "Nodes 2.0",
      "gridSpacing": "Grid spacing",
      "snapNodesToGrid": "Snap nodes to grid",
      "linkShape": "Link shape",
      "showConnectedLinks": "Show connected links",
      "viewAllSettings": "View all settings"
    },
    "groupSettings": "Group Settings",
    "groups": "Groups",
    "favoritesNoneDesc": "Inputs you favorite will show up here",
    "favoritesNoneHint": "In the Parameters tab, click {moreIcon} on any input to add it here",
    "noneSearchDesc": "No items match your search",
    "nodesNoneDesc": "NO NODES",
    "fallbackGroupTitle": "Group",
    "fallbackNodeTitle": "Node",
    "hideAdvancedInputsButton": "Hide advanced inputs",
    "hideAdvancedShort": "Hide advanced",
    "errors": "Errors",
    "noErrors": "No errors",
    "executionErrorOccurred": "An error occurred during execution. Check the Errors tab for details.",
    "findOnGithubTooltip": "Search GitHub issues for related problems",
    "getHelpTooltip": "Report this error and we'll help you resolve it",
    "enterSubgraph": "Enter subgraph",
    "seeError": "See Error",
    "promptErrors": {
      "prompt_no_outputs": {
        "desc": "The workflow does not contain any output nodes (e.g. Save Image, Preview Image) to produce a result."
      },
      "no_prompt": {
        "desc": "The workflow data sent to the server is empty. This may be an unexpected system error."
      },
      "server_error_local": {
        "desc": "The server encountered an unexpected error. Please check the server logs."
      },
      "server_error_cloud": {
        "desc": "The server encountered an unexpected error. Please try again later."
      }
    },
    "errorHelp": "For more help, {github} or {support}",
    "errorHelpGithub": "submit a GitHub issue",
    "errorHelpSupport": "contact our support",
    "resetToDefault": "Reset to default",
    "resetAllParameters": "Reset all parameters",
    "missingNodePacks": {
      "title": "Missing Node Packs",
      "unsupportedTitle": "Unsupported Node Packs",
      "cloudMessage": "This workflow requires custom nodes not yet available on Comfy Cloud.",
      "ossMessage": "This workflow uses custom nodes you haven't installed yet.",
      "ossManagerDisabledHint": "To install missing nodes, first run {pipCmd} in your Python environment to install Node Manager, then restart ComfyUI with the {flag} flag.",
      "installAll": "Install All",
      "installNodePack": "Install node pack",
      "unknownPack": "Unknown pack",
      "installing": "Installing...",
      "installed": "Installed",
      "applyChanges": "Apply Changes",
      "searchInManager": "Search in Node Manager",
      "viewInManager": "View in Manager",
      "collapse": "Collapse",
      "expand": "Expand"
    },
    "missingModels": {
      "urlPlaceholder": "Paste Model URL (Civitai or Hugging Face)",
      "or": "OR",
      "useFromLibrary": "Use from Library",
      "usingFromLibrary": "Using from Library",
      "unsupportedUrl": "Only Civitai and Hugging Face URLs are supported.",
      "metadataFetchFailed": "Failed to retrieve metadata. Please check the link and try again.",
      "import": "Import",
      "importing": "Importing...",
      "imported": "Imported",
      "importFailed": "Import failed",
      "typeMismatch": "This model seems to be a \"{detectedType}\". Are you sure?",
      "importAnyway": "Import Anyway",
      "alreadyExistsInCategory": "This model already exists in \"{category}\"",
      "customNodeDownloadDisabled": "Cloud environment does not support model imports for custom nodes in this section. Please use standard loader nodes or substitute with a model from the library below.",
      "importNotSupported": "Import Not Supported",
      "copyModelName": "Copy model name",
      "copyUrl": "Copy URL",
      "confirmSelection": "Confirm selection",
      "locateNode": "Locate node on canvas",
      "cancelSelection": "Cancel selection",
      "clearUrl": "Clear URL",
      "expandNodes": "Show referencing nodes",
      "collapseNodes": "Hide referencing nodes",
      "unknownCategory": "Unknown",
      "missingModelsTitle": "Missing Models",
      "assetLoadTimeout": "Model detection timed out. Try reloading the workflow.",
      "downloadAll": "Download all",
      "refresh": "Refresh",
      "refreshing": "Refreshing missing models.",
      "refreshFailed": "Failed to refresh missing models. Please try again."
    },
    "missingMedia": {
      "missingMediaTitle": "Missing Inputs",
      "image": "Images",
      "video": "Videos",
      "audio": "Audio",
      "locateNode": "Locate node",
      "expandNodes": "Show referencing nodes",
      "collapseNodes": "Hide referencing nodes",
      "uploadFile": "Upload {type}",
      "uploading": "Uploading...",
      "uploaded": "Uploaded",
      "selectedFromLibrary": "Selected from library",
      "useFromLibrary": "Use from Library",
      "confirmSelection": "Confirm selection",
      "cancelSelection": "Cancel selection",
      "or": "OR"
    }
  },
  "errorOverlay": {
    "errorCount": "{count} ERROR | {count} ERRORS",
    "seeErrors": "See Errors",
    "showMissingNodes": "Show missing nodes",
    "showMissingModels": "Show missing models",
    "showSwapNodes": "Show swap nodes",
    "showMissingMedia": "Show missing inputs",
    "missingNodes": "Some nodes are missing and need to be installed",
    "missingModels": "{count} required model is missing | {count} required models are missing",
    "swapNodes": "Some nodes can be replaced with alternatives",
    "missingMedia": "Some nodes are missing required inputs"
  },
  "help": {
    "recentReleases": "Recent releases",
    "helpCenterMenu": "Help Center Menu"
  },
  "progressToast": {
    "importingModels": "Importing Models",
    "downloadingModel": "Downloading model...",
    "downloadsFailed": "{count} download failed | {count} downloads failed",
    "allDownloadsCompleted": "All downloads completed",
    "noImportsInQueue": "No {filter} in queue",
    "failed": "Failed",
    "finished": "Finished",
    "pending": "Pending",
    "progressCount": "{completed} of {total}",
    "filter": {
      "all": "All",
      "completed": "Completed",
      "failed": "Failed"
    }
  },
  "exportToast": {
    "exportingAssets": "Exporting Assets",
    "preparingExport": "Preparing export...",
    "exportError": "Export failed",
    "exportFailed": "{count} export failed | {count} exports failed",
    "allExportsCompleted": "All exports completed",
    "noExportsInQueue": "No {filter} exports in queue",
    "exportStarted": "Preparing ZIP download...",
    "exportCompleted": "ZIP download ready",
    "exportFailedSingle": "Failed to create ZIP export",
    "downloadExport": "Download export",
    "downloadFailed": "Failed to download \"{name}\"",
    "retryDownload": "Retry download"
  },
  "workspace": {
    "inviteAccepted": "Invite Accepted",
    "addedToWorkspace": "You have been added to:",
    "inviteFailed": "Failed to Accept Invite",
    "viewWorkspace": "View workspace",
    "switchFailed": "Failed to switch workspace. Please try again."
  },
  "workspaceAuth": {
    "errors": {
      "notAuthenticated": "You must be logged in to access workspaces",
      "invalidFirebaseToken": "Authentication failed. Please try logging in again.",
      "accessDenied": "You do not have access to this workspace",
      "workspaceNotFound": "Workspace not found",
      "tokenExchangeFailed": "Failed to authenticate with workspace: {error}"
    }
  },
  "nightly": {
    "badge": {
      "label": "Preview Version",
      "tooltip": "You are using a nightly version of ComfyUI. Please use the feedback button to share your thoughts about these features."
    }
  },
  "nodeFilters": {
    "hideDeprecated": "Hide Deprecated Nodes",
    "hideDeprecatedDescription": "Hides nodes marked as deprecated unless explicitly enabled",
    "hideExperimental": "Hide Experimental Nodes",
    "hideExperimentalDescription": "Hides nodes marked as experimental unless explicitly enabled",
    "hideDevOnly": "Hide Dev-Only Nodes",
    "hideDevOnlyDescription": "Hides nodes marked as dev-only unless dev mode is enabled",
    "hideSubgraph": "Hide Subgraph Nodes",
    "hideSubgraphDescription": "Temporarily hides subgraph nodes from node library and search"
  },
  "secrets": {
    "title": "API Keys & Secrets",
    "description": "Secrets are encrypted and used for sensitive data like API keys.",
    "descriptionUsage": "Store your tokens here to enable downloading private and gated models from supported providers.",
    "modelProviders": "Model Providers",
    "addSecret": "Add Secret",
    "editSecret": "Edit Secret",
    "noSecrets": "No secrets stored. Add your first API key to get started.",
    "name": "Name",
    "namePlaceholder": "e.g., My API Key",
    "provider": "Provider",
    "providerHint": "Optional. Selecting a provider enables automatic token usage.",
    "secretValue": "Secret Value",
    "secretValuePlaceholder": "Enter your API key",
    "secretValuePlaceholderEdit": "Enter new value to change",
    "secretValueHint": "This value will be encrypted and cannot be viewed again.",
    "secretValueHintEdit": "Leave blank to keep the current value.",
    "createdAt": "Created {date}",
    "lastUsed": "Last used {date}",
    "deleteConfirmTitle": "Delete Secret",
    "deleteConfirmMessage": "Are you sure you want to delete \"{name}\"? This action cannot be undone.",
    "errors": {
      "nameRequired": "Name is required",
      "nameTooLong": "Name must be 255 characters or less",
      "providerRequired": "Provider is required",
      "secretValueRequired": "Secret value is required",
      "duplicateName": "A secret with this name already exists",
      "duplicateProvider": "A secret for this provider already exists"
    }
  },
  "essentials": {
    "loadImage": "Load Image",
    "saveImage": "Save Image",
    "loadVideo": "Load Video",
    "saveVideo": "Save Video",
    "load3DModel": "Load 3D model",
    "save3DModel": "Save 3D Model",
    "text": "Text",
    "batchImage": "Batch Image",
    "cropImage": "Crop Image",
    "resizeImage": "Resize Image",
    "rotate": "Rotate",
    "invert": "Invert",
    "canny": "Canny",
    "removeBackground": "Remove Background",
    "imageCompare": "Image compare",
    "extractFrame": "Extract frame",
    "loadStyleLora": "Load style",
    "lipsync": "Lipsync",
    "textGenerationLLM": "Text generation",
    "textTo3DModel": "Text to 3D model",
    "imageTo3DModel": "Image to 3D Model",
    "musicGeneration": "Music generation",
    "loadAudio": "Load Audio",
    "saveAudio": "Save Audio",
    "inpaintImage": "Inpaint image",
    "outpaintImage": "Outpaint image",
    "imageToImage": "Image to image",
    "textToImage": "Text to image",
    "poseToImage": "Pose to image",
    "cannyToImage": "Canny to image",
    "depthToImage": "Depth to image",
    "textToVideo": "Text to video",
    "imageToVideo": "Image to video",
    "poseToVideo": "Pose to video",
    "cannyToVideo": "Canny to video",
    "depthToVideo": "Depth to video"
  },
  "builderToolbar": {
    "label": "App Builder",
    "inputs": "Inputs",
    "outputs": "Outputs",
    "inputsDescription": "Choose inputs",
    "outputsDescription": "Choose outputs",
    "arrange": "Preview",
    "arrangeDescription": "Review app layout",
    "connectOutput": "Connect an output",
    "connectOutputBody1": "Your app needs at least one output to be connected before it can be saved.",
    "connectOutputBody2": "Switch to the 'Output' step and click on output nodes to add them here.",
    "switchToOutputs": "Switch to Outputs",
    "defaultViewLabel": "By default, this workflow will open as:",
    "app": "App",
    "appDescription": "Opens as an app by default",
    "nodeGraph": "Node graph",
    "nodeGraphDescription": "Opens as node graph by default",
    "viewApp": "View app",
    "saveAs": "Save as",
    "filename": "Filename",
    "emptyWorkflowTitle": "This workflow has no nodes",
    "emptyWorkflowPrompt": "Do you want to start with a template?"
  },
  "builderFooter": {
    "opensAsApp": "Open as an {mode}",
    "opensAsGraph": "Open as a {mode}"
  },
  "builderSave": {
    "successTitle": "Successfully saved",
    "successBody": "Would you like to view it now?",
    "successBodyApp": "This workflow will open in App Mode by default from now on.\n\nWould you like to view it now?",
    "successBodyGraph": "This workflow will open as a node graph."
  },
  "builderMenu": {
    "enterAppMode": "Enter app mode",
    "exitAppBuilder": "Exit app builder"
  },
  "cloudNotification": {
    "title": "Run ComfyUI in the Cloud",
    "message": "From setup to creation in seconds. Popular models, extensions, and powerful GPUs — ready when you are.",
    "feature1Title": "400 Free Credits Monthly",
    "feature2Title": "Works Anywhere, Instantly",
    "feature3Title": "Models Ready to Use",
    "feature4Title": "Top Custom Node Packs Pre-installed",
    "footer": "ComfyUI stays free and open source. Cloud is optional.",
    "continueLocally": "Continue Locally",
    "exploreCloud": "Try Cloud for Free"
  },
  "execution": {
    "generating": "Generating…",
    "saving": "Saving…",
    "loading": "Loading…",
    "encoding": "Encoding…",
    "decoding": "Decoding…",
    "processing": "Processing…",
    "resizing": "Resizing…",
    "generatingVideo": "Generating video…",
    "training": "Training…",
    "processingVideo": "Processing video…",
    "running": "Running…"
  }
}
